<template>
  <div id="fileTabId" class="project-table project-files-table" style="paddingTop: 0px;" v-loading="loading" element-loading-background="rgba(255,255,255,0.5)" loading-img='<span class="ant-spin-dot ant-spin-dot-spin"><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i></span>'>
    <div>
      <div class="content--options" style="padding-right: 0;">
        <div class="list" style="padding-top: 0;">
          <!-- 按钮组 -->
          <operation-buttons
            :button-list="buttonList"
            @uploadHandle="upload"
            @clickHandle="topButtonClick"
            class="float_left">
          </operation-buttons>
          <div class="float_right">
            <template v-if="prjType==1">
              <w-select class="file_select" size="small" style="width: 132px" v-model="tabType" @change="typeQueryList" placeholder="请选择">
                <w-option label="全局搜索" :value="0"></w-option>
                <w-option label="当前阶段搜索" :value="1"></w-option>
              </w-select>
            </template>
            <w-input :class="['file_search', prjType==1 ? 'file_search_all' : '']" size="small" ref="userNameInput" style="width: 220px;" v-model.trim="fileSearch" @enter="searchHandle" placeholder="输入关键字搜索">
              <i slot="prefix" class="r2-icon-action_search"></i>
              <i
                v-if="fileSearch!=''"
                class="r2-icon-nav_cancel cursor-pointer"
                slot="suffix"
                @click="fileSearch='';searchHandle('')">
              </i>
            </w-input>
            <i @click="moduleTypeQueryList" class="cursor-pointer hover-blue icon-type-change" :class="typeFilterData==='list'?'r2-icon-device_widgets_outlined':'r2-icon-editor_format_list_bulleted'" style="margin-left: 15px;"></i>
          </div>
        </div>
        <div class="list">
          <!-- 面包屑 -->
          <operation-crumb :items="pathItems" :search-value="searchVal" @change="queryPathList"></operation-crumb>
        </div>
      </div>
      <div class="dndCnt" id="dndCnt" :class="{dndCntShow: drawFileShow }">
        <div class="dnd-hintbox">
          <i></i>可将文件拖拽到框内任意区域
        </div>
        <!-- {{'isRecord：'+isRecord}} <br>
        {{'prjRole：'+prjRole}}<br>
        {{'isCompanyAdmin：'+isCompanyAdmin}} -->
        <!-- 展示 其他文件列表 -->
        <div class="tabcnt" id="projectTabCnt">
          <!-- 展示 其他工程文件列表 -->
          <Table v-if="typeFilterData === 'list'" :isScroll="false" :height="tableHeight" :fixedTable="true" :minHeight="true" :isHeight="false"
                  :showNoData="dataList.length === 0" :type="2" no-data-text="暂无数据" >
            <thead slot="header">
            <tr>
              <th width="240" class="checkAllth" :style="{paddingLeft: (!isPricingCollaboration || isRecord ? '16px' : 0)}">
                <template v-if="!isPricingCollaboration || isRecord">
                  <label class="checkall-label">
                    <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                    <!--<span class="margin-left-10">-->
                      <!--全选-->
                    <!--</span>-->
                  </label>
                  <span class="check-length" v-if="checkedLen > 0">
                    <span>已选中{{checkedLen}}项</span>
                    <!--<span>已选中{{checkedLen}}个文件/文件夹</span>-->
                  </span>
                </template>
                <span class="person-sort" @click="sortClick('name_chn')" v-if="+checkedLen === 0" :style="{paddingLeft: (!isPricingCollaboration || isRecord ? 0 : '20px')}">
                  名称
                  <template v-if="allFiles">
                    <i class="sort" v-if="sortFieldName !== 'name_chn'"></i>
                    <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                  </template>
                </span>
              </th>
              <th width="120" v-if="searchVal && !loading">所在目录</th>
              <th style="textAlign:left;" width="60" v-if="isAllType || !activeTab">项目阶段</th>
              <th
                width="80"
                class="break-all"
                v-if="!isRecord"
              >
                创建人
                <!--编制人-->
              </th>
              <th width="80">
                <span class="person-sort" @click="sortClick('modifiedTime')">
                  修改时间
                  <template v-if="allFiles">
                    <i class="sort" v-if="sortFieldName !== 'modifiedTime'"></i>
                    <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                  </template>
                </span>
              </th>
              <th width="80">创建时间</th>
              <th width="70">
                <span class="person-sort" @click="sortClick('size')">
                  文件大小
                  <template v-if="allFiles">
                    <i class="sort" v-if="sortFieldName !== 'size'"></i>
                    <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                  </template>
                </span>
              </th>
              <th width="70" class="is-operate">操作</th>
            </tr>
            </thead>
            <tbody slot="body" :class="{jiliangTab: +fileType === 2, size_96: +fileType === 2}">
            <tr
              v-for="(item,index) in dataList"
              :key="'tr_' + index + refreshIndex"
              height="40"
              :id="item.fileId"
              @click="trClick(index, item)"
              :class="['trItem', !item.permission && !item.folder ? 'no-permission' : '', item.checked ? 'active trItem' : '']"
              @mouseenter="trMouseEnter(item, index)"
              @mouseleave="trMouseLeave(item)"
            >
              <td width="240" :style="{paddingLeft: (isPricingCollaboration  ? 0 : '16px')}">
                <div class="l-boxd">
                  <template v-if="!isPricingCollaboration || isRecord">
                    <input v-if="item.fileProperties && isGTJXT(item)" type="checkbox" style="visibility:hidden;margin-right: 6px;" />
                    <label v-else class="w__checkbox" style="margin-right: 0;"
                           :class="{'is-checked': item.checked}" :style="{visibility: 'visible'}">
                    <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
                      <span class="w__checkbox__inner" @click.stop.prevent="trClick(index, item)"></span>
                      <input type="checkbox" class="w__checkbox__original" value="">
                    </span>
                    </label>
                  </template>
                  <div class="personHover l-boxd-d">
                    <template v-if="tabletype!=='projectList' && item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                      <i
                        :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? 'folder' : '']"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      ></i>
                    </template>
                    <template v-else-if="item.thumbnailUrl && +fileType === 2">
                      <img
                        :src="item.thumbnailUrl"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      />
                    </template>
                    <template v-else>
                      <i
                        :class="['file-icons', tabletype !== 'projectList' && (item.suffix==='gtjxt'||item.suffix==='GTJXT')? 'icon_':'icon_' + item.suffix,isGTJXT(item)?'icon_10000':'', 'icon_' + item.fileProperties.projectType, item.folder ? 'folder' : '', item.fileProperties.coProjectId ? 'xt': '']"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      ></i>
                    </template>
                    <span
                      v-if="renameData.showIndex !== index"
                      class="file-name"
                      v-on:click.stop="nameClick(item)"
                      v-on:dblclick.stop="fileRename(index, item.name, 'dbClick', item)"
                      :title="item.name"
                    >{{item.name}}</span>
                    <w-tag style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);" class="margin-left-10" size="mini" around v-if="item.fileType == 1 && item.fileProperties.region && renameData.showIndex !== index">{{item.fileProperties.region}}</w-tag>
                    <div class="w-rename" v-if="renameData.showIndex === index">
                      <w-input v-model="renameData.value" size="small" placeholder="请输入内容" autofocus @pressEnter="fileRenameSuccess(item)" @blur.stop="fileRenameSuccess(item)" input-class-name="renameInput"></w-input>
                    </div>
                  </div>
                </div>
              </td>
              <td width="120" v-if="searchVal && !loading">
                <a class="file-directory" @click.stop="handleDirectoryClick(item)">{{item.path | lastLevelDirectory}}</a>
              </td>
              <td v-if="isAllType || !activeTab" width="60">{{item.stage}}</td>
              <td width="80" class="break-all" v-if="!isRecord">
                {{item.originalCreatorName}}
                <!--{{item.folder ? "" : item.originalCreatorName}}-->
              </td>
              <td width="80">{{item.modifyTime}}</td>
              <td width="80">{{item.createTime}}</td>
              <td width="70">{{item.folder ? '' : item.size}}</td>
              <td width="70" class="is-operate" :key="index + '_icon_' + iconListKey">
                <div v-if="isRecord" class="operation operation_cont">
                  <template v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                    <el-tooltip placement="bottom" :content="previewIcon[capitalize(item.suffix)].name" arrow-point-at-center>
                      <a @click.stop="previewData(item, previewIcon[capitalize(item.suffix)], 2)"
                        :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon]">
                      </a>
                    </el-tooltip>
                  </template>
                  <template v-if="isGTJXT(item)">
                    <el-tooltip placement="bottom" :content="previewIcon[capitalize('GTJ')].name" arrow-point-at-center>
                      <a @click.stop="previewgtjxt(item)"
                        :class="['preview-icon w-icon-' + previewIcon[capitalize('GTJ')].icon]">
                      </a>
                    </el-tooltip>
                  </template>
                  <el-tooltip v-if="(isCompanyAdmin || isModuleView) && !isGTJXT(item)" placement="bottom" content="下载" arrow-point-at-center>
                    <a class="r2-icon-action_get_app hover-blue cursor-pointer" v-on:click.stop="downloadFile(item)"></a>
                  </el-tooltip>
                </div>
                <div v-else-if="item.fileProperties.coProjectId">
                  <el-tooltip placement="bottom" content="打开工程" arrow-point-at-center>
                    <a class="r2-icon-open hover-blue cursor-pointer" v-on:click.stop="openGCCP6('open', item.path)"></a>
                  </el-tooltip>
                </div>
                <!--计价协同文件，右侧操作按钮不显示-->
                <div v-else-if="item.folder && isPricingCollaboration"></div>
                <div v-else-if="isGTJXT(item)&&filePrivilege !== 'view'" class="operation operation_cont">
                  <el-tooltip placement="bottom" content="协同建模" arrow-point-at-center>
                    <a class="w-icon-xietongjianmo hover-blue cursor-pointer" v-on:click.stop="goGTJXTModel(item)"></a>
                  </el-tooltip>
                  <template v-if="iconListKey && previewIcon[capitalize('GTJ')] && previewIcon[capitalize('GTJ')].suffix">
                    <el-tooltip placement="bottom" :content="previewIcon[capitalize('GTJ')].name" arrow-point-at-center>
                      <a @click.stop="previewgtjxt(item)"
                        :class="['preview-icon w-icon-' + previewIcon[capitalize('GTJ')].icon]">
                      </a>
                    </el-tooltip>
                  </template>
                </div>
                <div v-else-if="filePrivilege == 'view'" class="operation operation_cont">
                  <template v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                    <el-tooltip placement="bottom" :content="previewIcon[capitalize(item.suffix)].name" arrow-point-at-center>
                      <a @click.stop="previewData(item, previewIcon[capitalize(item.suffix)], 2)"
                        :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon]">
                      </a>
                    </el-tooltip>
                  </template>
                </div>
                <div v-else-if="!item.isCreateFolder" class="operation operation_cont">
                  <!-- <template v-if="item.folder && isRootPrivelege">
                    <el-tooltip placement="bottom" content="权限设置" arrow-point-at-center>
                      <a class="r2-icon-authority hover-blue cursor-pointer" v-on:click.stop="contextMenuFilePrivilege(item)"></a>
                    </el-tooltip>
                  </template> -->
                  <template v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                    <el-tooltip placement="bottom" :content="previewIcon[capitalize(item.suffix)].name" arrow-point-at-center>
                      <a @click.stop="previewData(item, previewIcon[capitalize(item.suffix)], 2)"
                        :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon]">
                      <!--预览 .gbq5.filePrivilege !== 'view' 文件-->
                      </a>
                    </el-tooltip>
                  </template>
                  <el-tooltip placement="bottom" content="下载" arrow-point-at-center>
                    <a class="r2-icon-action_get_app hover-blue cursor-pointer" v-on:click.stop="downloadFile(item)"></a>
                  </el-tooltip>
                  <!-- 有权限时 才显示已下按钮 -->
                  <template v-if="['delete', 'grant'].includes(filePrivilege) && item.permission">
                    <el-tooltip placement="bottom" content="删除" arrow-point-at-center>
                      <a class="r2-icon-action_delete_outline hover-blue cursor-pointer" v-on:click.stop="delOneFile(item)"></a>
                    </el-tooltip>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </Table>
          <div v-else class="listcnt" :style="{height: 'auto', minHeight: tableHeight + 'px', overflow: 'unset'}">
            <template v-if="!isPricingCollaboration || isRecord">
              <div class="imgItem-checkall" v-if="!isRecord || (prjRole === 1 || isCompanyAdmin || isModuleView)">
                <label class="checkall-label">
                  <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                  全选
                </label>
                <span class="check-length">
                <span v-if="checkedLen > 0">已选中{{checkedLen}}个文件/文件夹</span>
              </span>
              </div>
            </template>
            <div
              class="size_96 thumbnail-item relative"
              :class="[item.checked ? 'active trItem imgItem' : 'trItem imgItem', !item.permission && !item.folder ? 'no-permission' : '', isGTJXT(item)?'nohoverclass' : '']"
              v-for="(item,index) in dataList"
              :id="item.fileId"
              :key="'tr_' + index + refreshIndex"
              @mouseenter="trMouseEnter(item,index)"
              @mouseleave="trMouseLeave(item)"
              :style="{height: (isAllType||!activeTab) ? '200px':''}"
            >
              <div class="absolute more" style="right: 5px; top: 2px;z-index: 9;" v-if="!(isPricingCollaboration && item.folder &!isRecord)">
                <w-dropdown @command="handlerAction" trigger="click">
                    <span class="w__dropdown-link" @click.stop="_clickHandle(item, index)">
                       <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i></span>
                    </span>
                  <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                    <!--计价协同项目-计价协同工程-非备案库-->
                    <template v-if="isPricingCollaboration && item.fileProperties.coProjectId && !isRecord">
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'openGCCP6'}">打开工程</w-dropdown-item>
                    </template>
                    <template v-else-if="isGTJXT(nowPreview.item)">
                      <!-- 协同文件 -->
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">查看模型</w-dropdown-item>
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'gtjxtmodel'}" v-if="!isRecord">协同建模</w-dropdown-item>
                    </template>
                    <template v-else-if="isRecord">
                      <!-- 备案空间 -->
                      <w-dropdown-item :disabled="contextMenuDisable.viewModel" :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">
                        查看模型
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.preview" :command="{item, fn: 'contextmenuClick', type: 'preview'}">预览</w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.download" :command="{item, fn: 'downLoadFiles', type: null}" v-if="isCompanyAdmin || isModuleView">下载</w-dropdown-item>
                    </template>
                    <template v-else>
                      <w-dropdown-item :disabled="contextMenuDisable.viewModel" :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">查看模型</w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.preview" :command="{item, fn: 'contextmenuClick', type: 'preview'}">预览</w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.download" :command="{item, fn: 'downLoadFiles', type: null}">下载</w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.move||!allFiles" :command="{item, fn: 'moveFilesTap'}"
                                       v-if="!(+user.userType === 3 && tabletype === 'companyList')">
                        移动到
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.rename" :command="{item, fn: 'contextMenuFileRename'}"
                                       v-if="!(+user.userType === 3 && tabletype === 'companyList')">
                        重命名
                      </w-dropdown-item>
                      <!--<w-dropdown-item :disabled="!isPrivelege" :command="{item, fn: 'contextMenuFileShare'}">-->
                      <!--权限管理-->
                      <!--</w-dropdown-item>-->
                      <w-dropdown-item :disabled="contextMenuDisable.delete" :command="{item, fn: 'deleteFiles'}" divided
                                       v-if="!(+user.userType === 3 && tabletype === 'companyList')">
                        删除
                      </w-dropdown-item>
                    </template>
                  </w-dropdown-menu>
                </w-dropdown>
              </div>
              <template v-if="!isPricingCollaboration || isRecord">
                <label role="checkbox" aria-checked="true" class="w__checkbox imgItem-checkbox"
                       :class="{'is-checked': item.checked}" :style="{visibility: !isGTJXT(item) && (!isRecord || (isRecord && (prjRole === 1 || isCompanyAdmin || isModuleView)))? '' : 'hidden'}"
                       @click.stop="checkboxTap(item, index, $event)">
                <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': item.checked}">
                  <span class="w__checkbox__inner"></span>
                  <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
                </span>
                </label>
              </template>
              <div class="imgItem-box">
                <template v-if="tabletype!=='projectList' && item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                  <i
                    :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? 'folder' : '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  ></i>
                </template>
                <template v-else-if="item.thumbnailUrl">
                  <img
                    :src="item.thumbnailUrl"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  />
                </template>
                <template v-else>
                  <i
                    :class="['file-icons', 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? 'folder' : '', item.fileProperties.coProjectId ? 'xt': '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  ></i>
                </template>
                <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                  <p>创建时间：{{item.createTime}}</p>
                  <p>文件大小：{{item.size}}</p>
                  <p v-if="!isRecord">编制人：{{item.originalCreatorName}}</p>
                  <template v-if="+item.fileType === 1">
                    <p>
                      文件类型：
                      <template v-if="+item.extraInfo === 1">概算</template>
                      <template v-else-if="+item.extraInfo === 2">预算</template>
                      <template v-else-if="+item.extraInfo === 3">结算</template>
                      <template v-else>审核</template>
                    </p>
                  </template>
                  <template v-if="+item.fileType === 2">
                    <p>
                      <label>工程类别：</label>
                      {{item.fileProperties.projectCategory || '【无】'}}
                    </p>
                    <p>
                      <label>结构类型：</label>
                      {{item.fileProperties.structureCategory || '【无】'}}
                    </p>
                    <p>
                      <label>清单规则：</label>
                      {{item.fileProperties.listRule || '【无】'}}
                    </p>
                    <p>
                      <label>定额规则：</label>
                      {{item.fileProperties.quotaRule || '【无】'}}
                    </p>
                  </template>
                </div>
              </div>
              <div class="imgItem-name">
                <div v-if="isAllType || !activeTab" class="imgItem-filetime">{{item.stage}}</div>
                <a
                  class="imgItem-name-a"
                  v-if="renameData.showIndex !== index"
                  v-on:click.stop="nameClick(item)"
                  v-on:dblclick.stop="fileRename(index,item.name, '', item)"
                  :title="item.name"
                >{{item.name}}</a>
                <div class="w-rename" v-if="renameData.showIndex === index">
                  <w-input size="small" autofocus style="width: 100%;" v-model="renameData.value" @blur="handleRenameBlur(item)" @click.stop="" input-class-name="renameInput"></w-input>
                </div>
              </div>
              <div class="imgItem-filetime">{{item.modifyTime}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mydrag-sel" v-if="mydragSelShow"></div>
      <div class="mydrag-icon" v-show="mydragIconShow"></div>
      <ul class="contextMenu" v-show="contextMenuShow && !isPricingCollaboration">
        <template v-if="isGTJXT(nowPreview.item)">
          <!-- gtjxt工程 -->
          <li @click="contextmenuClick('viewModel')">
            查看模型
          </li>
          <li v-if="!isRecord" @click="contextmenuClick('gtjxtmodel')">协同建模</li>
        </template>
        <template v-else-if="isRecord">
          <!-- 备案空间 -->
          <li :class="{disable:contextMenuDisable.viewModel}"
              @click="contextmenuClick('viewModel')"
          >查看模型
          </li>
          <li :class="{disable:contextMenuDisable.preview}" @click="contextmenuClick('preview')">预览</li>
          <li v-if="isCompanyAdmin || isModuleView" :class="{disable:contextMenuDisable.download}" @click="downLoadFiles(null)">下载</li>
        </template>
        <template v-else>
          <li :class="{disable:contextMenuDisable.viewModel}"
              @click="contextmenuClick('viewModel')"
          >查看模型
          </li>
          <li :class="{disable:contextMenuDisable.preview}" @click="contextmenuClick('preview')">预览</li>
          <li :class="{disable:contextMenuDisable.download}" @click="downLoadFiles(null)">下载</li>
          <li
            v-if="!(+user.userType === 3 && tabletype === 'companyList')"
            :class="{disable:contextMenuDisable.move||!allFiles}"
            @click="moveFilesTap(false)"
          >移动到
          </li>
          <li
            v-if="!(+user.userType === 3 && tabletype === 'companyList')"
            :class="{disable:contextMenuDisable.rename}"
            @click="contextMenuFileRename"
          >重命名
          </li>
          <!-- <li :class="{disable:!isPrivelege}"
              @click="contextMenuFilePrivilege()">
              权限管理
          </li> -->
          <li class="split"></li>
          <li class="delete"
            v-if="!(+user.userType === 3 && tabletype === 'companyList')"
            :class="{disable:contextMenuDisable.delete}"
            @click="deleteFiles"
          >删除
          </li>
        </template>
      </ul>
      <!-- 权限弹框 -->
      <w-dialog :showScrollbar="false" @close="closeDialogPrivilege" :box-style="{'z-index': 1009}"  customClass="privilege-dialog" :show="privilegeDialogShow">
        <div slot="header">
          <span class="w__dialog--title">权限管理
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" class="pri-tips">
              <div class="pri-title">
                <span></span>
                <span>不可见</span>
                <span>查看者</span>
                <span>编辑者</span>
                <span>管理者</span>
              </div>
              <ul class="pri-cnt">
                <li v-for="(item, index) of opration" :key="index">
                  <span>{{item.name}}</span>
                  <span :class="{'disable':!item.none}"><i class="r2-icon-nav_check"></i></span>
                  <span :class="{'disable':!item.view}"><i class="r2-icon-nav_check"></i></span>
                  <span :class="{'disable':!item.update}"><i class="r2-icon-nav_check"></i></span>
                  <span :class="{'disable':!item.delete}"><i class="r2-icon-nav_check"></i></span>
                </li>
              </ul>
            </div>
            <i class="r2-icon-action_help_outline" style="line-height: 22px;"></i>
          </el-tooltip>
          </span>
        </div>
        <div class="pri_content" v-loading="privilegeLoading" element-loading-background="rgba(255,255,255,0.5)" loading-img='<span class="ant-spin-dot ant-spin-dot-spin"><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i></span>'>
          <ul class="pri_header">
            <li class="pri_item pri_item_1">姓名</li>
            <li class="pri_item pri_item_2">账号</li>
            <li class="pri_item pri_item_3">项目权限</li>
            <li class="pri_item pri_item_4">
              文件夹权限
            </li>
          </ul>
          <div class="pri_body">
            <ul class="pri_tr" v-for="(item, key) of privilegeData" :key="key">
              <li class="pri_item pri_item_1 ellipsis-1">{{item.name}}</li>
              <li class="pri_item pri_item_2 ellipsis-1">{{item.account}}</li>
              <li class="pri_item pri_item_3 ellipsis-1">{{item.roleId | roleFilter}}</li>
              <li class="pri_item pri_item_4">
                <w-radio style="margin-right: 21px;" :value="item.permission" label="none" @change="choosePri('none', key)">不可见</w-radio>
                <w-radio style="margin-right: 21px;" :value="item.permission" label="view" @change="choosePri('view', key)">查看</w-radio>
                <w-radio style="margin-right: 21px;" :value="item.permission" label="update" @change="choosePri('update', key)">编辑</w-radio>
                <w-radio style="margin-right: 21px;" :value="item.permission" label="delete" @change="choosePri('delete', key)">管理</w-radio>
              </li>
            </ul>
            <div v-if="privilegeData.length==0" style="color: #999;line-height: 50px;" class="text-align-center">
              无数据
            </div>
          </div>
          <div class="pri_foot">
            <w-button type="primary" @click="confirmPri">确定</w-button>
            <w-button type="minor" @click="privilegeDialogShow=false">取消</w-button>
          </div>
        </div>
      </w-dialog>
      <!-- 权限弹框 -->
      <w-dialog customClass="del-doalog" :show="msg.show">
        <div class="dialog-body">
          <div class="dialog-img">
            <i class="w-icon-tishi"></i>
          </div>
          <div class="dialog-text">
            <div>
              您{{msg.type}}的
              <span v-if="msg.isShort&&msg.arr.length>2" @click="msgHandle" class="cursor-pointer"><i class="color-link">{{msg.arr.slice(0,2).join('，')}}</i>等</span>
              <span v-else-if="msg.arr.length<3" class="color-link">{{msg.arr.join('，')}}</span>
              <span v-else class="color-link">{{msg.arr.join('，')}}</span>
              文件因权限问题，操作失败，您可以联系项目管理者为您开通文件夹权限。
            </div>
          </div>
        </div>
        <div slot="footer">
          <w-button type="primary" @click="msgConfirm">确定</w-button>
          <!--<span class="ui-btn ui-btn_blue" @click="msgConfirm">确定</span>-->
        </div>
      </w-dialog>
      <!-- 移动到弹层 -->
      <MoveFile v-if="moveLayerShow" :pagetype="tabletype" @affirm="moveAffirm" @cancel="moveCancel"/>
      <!-- 移动到存在多个相同文件替换提示 -->
      <ReplaceFilesHint v-if="replaceFileHintShow" @btnclick="replaceFileHintBtnClick"/>
      <verify-code  @dialogVisibleEvent='showVerify=false' :showVerify="showVerify" @verifyConfirm='verifyConfirm'></verify-code>
    </div>
    <!-- 分页 -->
    <div class="page-box" v-if="total > 0">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total">
      </w-pagination>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-useless-escape */
import _ from 'lodash'
import {backendUrl} from '@/assets/js/config'
import VerifyCode from '@/components/VerifyCode'
import Bus from '@/assets/utils/bus'
import {sizeConver, formatDay, capitalize} from '@/assets/utils'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
import Table from '_c/common/Table/Index.vue'
import {mapState, mapMutations} from 'vuex'
import {getCookie} from '@/assets/utils/CommonUtil'
import {getFileTyeIconClass} from '@/assets/utils/space'
import MoveFile from '_c/common/MoveFile/Index.vue'
import ReplaceFilesHint from '_c/common/ReplaceFilesHint/Index.vue'
import SpaceService from '@/assets/service/space'
import r2Project from '@/assets/service/r2Project'
import { formatDate } from '@/assets/utils/Date'
import LoginService from '@/assets/service/login'
import {
  OperationButtons,
  OperationCrumb,
  OperationFileType,
  OperationModuleType,
  OperationSearch
} from '@/components/common'
import previewButtonsMixin from '@/assets/mixins/preview-buttons'
import {openIPC} from '_c/common/openIPC'

const opration = [
  {name: '上传', delete: true, update: true, view: false, none: false},
  {name: '下载', delete: true, update: true, view: false, none: false},
  {name: '重命名', delete: true, update: true, view: false, none: false},
  {name: '新建文件夹', delete: true, update: true, view: false, none: false},
  {name: '预览', delete: true, update: true, view: true, none: false},
  {name: '移动', delete: true, update: false, view: false, none: false},
  {name: '删除', delete: true, update: false, view: false, none: false}
]
const unsuportfiles = [
  'RVT', 'STP', 'DXF', 'DAE', 'FBX', 'STL', '3DS', 'DWG', 'DWF', 'OBJ', 'SKP', 'GMP', 'PANO', 'MP4', 'GQI4', 'GDQ', 'GTJ', 'GTJJY', 'GTJXS', 'GQIJY', 'GQIXS'
]
let isOnShift // 是否长按shift备案库预览功能正在研发中，敬请期待
// let isOnCtrl // 是否长按ctrl
let clickIndex // 数据点击Index
let trIsMouseEnter // 鼠标是否在数据上
let mouserEnterItemIndex = -1 // 鼠标hover数据index
let isDown // 未checked数据框选判断
let isDownSel // checked数据框选判断
let isAddBox
let starX
let starY
let deleteFileList = []
let downLoadTimer // 删除文件列表
let moveFilesPath = []
let copyFilesPath = []
let nameClickTimer
let role
switch (+getCookie('role')) {
  case 1:
    role = '管理员'
    break
  case 2:
    role = '总负责人'
    break
  case 3:
    role = '数据库负责人'
    break
  case 4:
    role = '普通员工'
    break
  default:
    role = '管理员'
    break
}
// let floderFiles = []
export default {
  mixins: [previewButtonsMixin],
  components: {
    Table,
    OperationButtons,
    OperationCrumb,
    OperationFileType,
    OperationModuleType,
    OperationSearch,
    MoveFile,
    ReplaceFilesHint,
    VerifyCode
  },
  data () {
    return {
      showVerify: false,
      filePrivilege: 'delete',
      opration,
      pagination: {
        hideOnSinglePage: true
      },
      privilegeLoading: false,
      privilegeData: [],
      drawFileShow: false,
      // 文件替换提示
      replaceFileHintShow: false,
      // 移动到弹层显示
      moveLayerShow: false,
      // 下载进度弹层显示
      downloadProgressLaterShow: false,
      // 下载进度
      // downloadProgressValue: 0,
      typeFilterData: 'list',
      // 文件筛选类型
      fileType: 0,
      // 文件阶段 1. 本阶段； 0. 全部文件
      tabType: 1,
      // 是否全部文件
      isAllType: false,
      // 右键
      contextMenuShow: false,
      // 右键菜单禁用状态
      contextMenuDisable: {
        viewModel: true,
        preview: true,
        download: false,
        delete: false,
        move: false,
        rename: false,
        copy: false,
        unloading: true // 右键菜单 转存 置灰
      },
      // 是否显示框选框
      mydragSelShow: false,
      // 是否显示拖拽图标
      mydragIconShow: false,
      isCheckAll: false,
      // 选择文件数量
      checkedLen: 0,
      // 列表数据
      dataList: [],
      loading: false,
      refreshIndex: 0,
      // 删除提示
      // delDialogShow: false,
      // 权限管理
      privilegeDialogShow: false,
      // 重命名框
      renameData: {
        suffix: '',
        value: '',
        showIndex: -1
      },
      // 排序规则  倒叙 1  顺序 0
      sortType: 1,
      // 排序字段
      sortFieldName: 'modifiedTime',
      // 搜索值
      searchVal: '',
      fileSearch: '',
      // 当前路径
      path: '/',
      pageNum: 1,
      pageSize: 50,
      total: 0,
      buttonList: [
        // 'upload', // 上传
        // 'addFolder', // 新建文件夹
        // 'refresh' // 刷新
      ],
      pathItems: [
        {
          name: '全部文件' // 情况三: 只包含name字段 则触发父组件toFolder(文件夹路径)
        }
      ],
      nowPreview: {
        index: -1,
        item: {}, // 当前正在预览的项
        icon: {} // 当前预览项 配置的预览按钮
      },
      iconHoverIndex: -1, //
      isRaname: false,
      user: {},
      porjectInf: {},
      isCompanyAdmin: false,
      msg: {
        type: '',
        show: false,
        isShort: true,
        arr: []
      },
      isRecord: /\/database\/data\/record\//.test(this.$route.path),
      gccsToken: ''
      // isPricingCollaboration: true // 是否是计价协同项目
    }
  },
  props: {
    tabletype: {
      type: String,
      default: 'projectList'
    }
  },
  filters: {
    roleFilter: function (data){
      if (+data === 2){
        return '项目编辑'
      } else {
        return '项目管理'
      }
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  computed: {
    ...mapState({
      workspace: state => state.space.workspace,
      personalFilter: state => state.spacefilter.personalFilter,
      enterpriseFilter: state => state.spacefilter.enterpriseFilter,
      projectFilter: state => state.spacefilter.projectFilter,
      activeTab: state => state.project.activeTab,
      prjStatus: state => state.project.status,
      prjName: state => state.project.name,
      prjType: state => state.project.prjType,
      prjRole: state => state.project.role,
      prjCategory: state => state.project.prjCategory
    }),
    isRootPrivelege: function () {
      return (this.prjRole === 1 || this.isCompanyAdmin) && this.pathItems.length === 1 && +this.tabType === 1 && this.activeTab
    },
    isPrivelege: function () {
      let isChooseOneFolder = false
      let chooseFile = this.dataList.filter(item => item.checked)
      if (chooseFile && chooseFile.length === 1 && chooseFile[0].folder){
        isChooseOneFolder = true
        this.chooseFloder = chooseFile[0]
      }
      return (this.prjRole === 1 || this.isCompanyAdmin) && this.pathItems.length === 1 && isChooseOneFolder && +this.tabType === 1 && this.activeTab
    },
    allFiles: function (){
      return !this.isAllType && this.activeTab
    },
    // 是否是计价协同项目
    isPricingCollaboration () {
      return !!(this.prjCategory === 1)
    }
  },
  watch: {
    activeTab: function () {
      this.searchVal = ''
      this.fileSearch = ''
      this.pathItems = [{name: `${this.getPathNameG()}`}]
      this.fileType = 0
      this.tabType = 1
      this.filePrivilege = 'delete'
      this.$forceUpdate()
      this.lock = false
      initData(this, true)
    },
    filePrivilege: function (data){
      window.privilege = data
    },
    prjStatus: {
      handler (){
        if (this.prjStatus && +this.prjStatus[this.activeTab] === 2 && this.lock){
          initData(this, true)
        }
      },
      deep: true,
      immediate: true
    },
    tabletype: function (val) {
      if (val === 'personalList') {

      }
    },
    dataList: function () {
      this.setContextmenuStatusAndTopButtons()
    },
    prjName: function () {
      this.getFileId()
    },
    prjRole: function (val) {
      if (role !== '总负责人') {
        if (+val === 1) {
          role = '项目管理者'
        } else {
          role = '项目编辑者'
        }
      }
      this.setContextmenuStatusAndTopButtons()
    },
    prjCategory: {
      handler (value){
        setTimeout(() => {
          initEvent(this, (value !== 1 || this.isRecord))
        }, 100)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapMutations({
      setPersonalTypeFilter: 'spacefilter/SET_PERSONAL_FILTER',
      setEnterproseTypeFilter: 'spacefilter/SET_ENTERPRISE_FILTER',
      setProjectTypeFilter: 'spacefilter/SET_PROJECT_FILTER',
      setRoot: 'project/SET_ROOT'
    }),
    // 失败文件展示
    msgHandle () {
      this.msg.isShort = false
    },
    // 失败文件 确定
    msgConfirm () {
      this.msg.show = false
    },
    _clickHandle (item, trIsMouseEnter) {
      let _self = this
      _self.contextMenuShow = false
      if (trIsMouseEnter > -1) {
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        if (_self.isGTJXT(dataList[trIsMouseEnter])) {
          _self.contextMenuDisable = {
            viewModel: false,
            preview: true
          }
          // _self.judgeGTJXT()
          _self.judgePreview()
          return
        } else {
          _self.contextMenuDisable.noShare = false
          _self.contextMenuDisable.delete = false
          _self.contextMenuDisable.download = false
          _self.contextMenuDisable.copyToCompanySpace = false
          _self.contextMenuDisable.move = false
        }
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        }
        _self.$nextTick(() => {
          _self.judgePreview()
          dataList.forEach((item, index) => {
            if (item.checked) {
              checkedCount++
            }
          })
        })
      }
    },
    // 缩略图-更多操作，下拉菜单
    handlerAction ({item, fn, type}) {
      this[fn](type)
    },
    // 1.1 权限变更
    choosePri (data, key){
      this.privilegeData[key].oldPermission = this.privilegeData[key].permission
      // if(this.privilegeData[key].oldPermission == data){
      //   this.privilegeData[key].permission = 'none'
      // } else {
      this.privilegeData[key].permission = data
      // }
      this.$forceUpdate()
    },
    // 1.2 权限变更提交
    confirmPri () {
      let query = {
        fileId: this.priId ? this.priId : this.chooseFloder.fileId,
        workspaceId: getCookie('projectWorkspaceIdValue')
      }
      let params = []
      this.privilegeData.map(item => {
        if (item.oldPermission && item.oldPermission !== item.permission) {
          params.push({
            'gldUserId': item.memberId,
            'permission': item.permission
          })
        }
      })
      this.privilegeLoading = true
      r2Project.postFilePrivilege(this.$route.params.id, query, params).then(res => {
        this.privilegeLoading = false
        if (res.code === 200){
          this.privilegeDialogShow = false
        } else if (+res.code === 240015 || +res.code === 403){
          this.$message({
            type: 'error',
            message: '无访问权限！'
          })
        } else {
          this.$message({
            type: 'error',
            message: '失败了，请稍后重试！'
          })
        }
      }).catch(() => {
        this.privilegeLoading = false
        this.$message({
          type: 'error',
          message: '失败了，请稍后重试！'
        })
      })
    },
    // 1.3 右键权限
    contextMenuFilePrivilege (item) {
      let params
      if (item) {
        this.priId = item.fileId,
        params = {
          fileId: item.fileId,
          workspaceId: getCookie('projectWorkspaceIdValue')
        }
      } else {
        if (!this.isPrivelege){
          return
        }
        params = {
          fileId: this.chooseFloder.fileId,
          workspaceId: getCookie('projectWorkspaceIdValue')
        }
      }
      this.privilegeDialogShow = true
      this.privilegeLoading = true
      r2Project.getPrivilegeMembers(this.$route.params.id, params).then(res => {
        this.privilegeLoading = false
        if (res.code === 200){
          this.privilegeData = res.data
        } else if (+res.code === 240015 || +res.code === 403){
          this.$message({
            type: 'error',
            message: '无访问权限！'
          })
        } else {
          this.$message({
            type: 'error',
            message: '失败了，请稍后重试！'
          })
        }
      }).catch(() => {
        this.privilegeLoading = false
        this.$message({
          type: 'error',
          message: '失败了，请稍后重试！'
        })
      })
    },
    // 1.4 权限弹框关闭
    closeDialogPrivilege () {
      this.privilegeDialogShow = false
    },
    // 1.5 获取是不是项目空间中的GTJXT文件
    isGTJXT (item){
      // if (this.tabletype === 'projectList' && item && item.fileProperties && +item.fileProperties.projectType === 10000 && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT') {
      if (this.tabletype === 'projectList' && (item.suffix + '').toUpperCase() === 'GTJXT') {
        return true
      } else {
        return false
      }
    },
    // 1.6 协同建模
    goGTJXTModel (item, isContextmenu) {
      // let wsId = getCookie('projectWorkspaceIdValue')
      let fileId = item.fileId
      // let projectid = this.$route.params.id
      // let prjname = this.prjName
      // this._sendIOLog('触发协同建模', '协同建模模块', '10011', '-102019', isContextmenu ? '3' : '2', projectid, prjname)
      // this._sendIOLog('协同建模', 'web端', '10063', '-102019', isContextmenu ? '3' : '2', projectid, prjname)
      window.open(`/cloudsynergy/fileId/${fileId}`, '_blank')
    },

    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      initData(this, true)
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      initData(this, true)
    },
    // 将 val 全部转换成小写
    capitalize (val) {
      return capitalize(val, true, true)
    },
    // 全选
    checkAll () {
      let dataList = [...this.dataList]
      dataList = dataList.map(item => {
        if (!this.isGTJXT(item)) {
          item.checked = this.isCheckAll
        }
        return {
          ...item
        }
      })
      this.dataList = dataList
    },
    checkboxTap (item, index, e) {
      e.preventDefault()
      e.stopPropagation()
      this.$set(this.dataList[index], 'checked', !item.checked)
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked && !this.isGTJXT(tr)) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
      this.refreshIndex++
      // 设置 右键菜单 和 顶部操作按钮组
      this.setContextmenuStatusAndTopButtons()
    },
    trMouseEnter (item, index) {
      trIsMouseEnter = index
      if (item.checked) {
        mouserEnterItemIndex = index
      }
    },
    trMouseLeave (item) {
      trIsMouseEnter = -1
      mouserEnterItemIndex = -1
    },
    // 单行选中
    trClick (index, item) {
      if (this.isGTJXT(item) || (this.isRecord && !(this.prjRole === 1 || this.isCompanyAdmin || this.isModuleView)) || this.isPricingCollaboration) {
        return
      }
      let dataobj = {...this.dataList[index]}
      this.contextMenuShow = false
      dataobj.checked = !dataobj.checked
      if (!dataobj.checked) {
        isDown = false
      }
      if (isOnShift) {
        if (clickIndex === undefined) {
          return
        }
        let dataList = [...this.dataList]
        dataList = dataList.map((item, itemindex) => {
          if (clickIndex >= index) {
            if (itemindex >= index && itemindex <= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          } else if (clickIndex < index) {
            if (itemindex <= index && itemindex >= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          }
          return {
            ...item
          }
        })
        this.dataList = dataList
      } else {
        clickIndex = index
        this.dataList.splice(index, 1, dataobj)
      }
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked && !this.isGTJXT(tr)) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
    },
    // 排序
    sortClick (name) {
      if (!this.allFiles){
        return
      }
      if (this.sortFieldName === name) {
        this.sortType = +this.sortType === 1 ? 0 : 1
      } else {
        this.sortFieldName = name
        this.sortType = 1
      }
      initData(this)
    },
    // 判断是否已经二次验证
    // async isDoubleVerify (){
    //   const userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
    //   this.phone = userinfo.passwordMobile
    //   let result = await new Promise((resolve, reject) => {
    //     LoginService.isDoubleVerify(userinfo.passwordMobile).then(res => {
    //       if (res.code === 200){
    //         if (res.data){ // 需要二次验证-弹出弹框
    //           console.log('未二次验证！')
    //           this.showVerify = true
    //           resolve(true)
    //         } else { // 已经验证过
    //           console.log('二次验证已通过！')
    //           resolve(false)
    //         }
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   })
    //   return result
    // },

    // 二次验证---确定
    verifyConfirm (){
      console.log('验证成功，请继续操作！')
    },
    // 删除文件
    async delOneFile (item) {

      deleteFileList = [item]
      this.sentLog(100112038, {count: 1})

      // if (this.tabletype !== 'personalList'){
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     return false
      //   }
      // }

      this.$confirm({
        message: '确定要把文件删除？',
        type: 'primary',
        tips: '删除文件可以通过“回收站”来还原',
        submit: () => {
          delFiles(this)
        },
        cancel: () => {
        },
        submitText: '确定删除',
        cancelText: '取消'
      })
    },
    // 多文件删除
    async deleteFiles (item) {

      if (this.contextMenuDisable.delete) {
        return
      }
      if (this.contextMenuShow) {
        this.sentLog(100112039, {count: this.checkedLen})
      } else {
        this.sentLog(100112037, {count: this.checkedLen})
      }

      // if (this.tabletype !== 'personalList'){
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     return false
      //   }
      // }
      this.contextMenuShow = false
      this.findSelectItems()
      this.$confirm({
        message: '确定要把文件删除？',
        type: 'primary',
        tips: '删除文件可以通过“回收站”来还原',
        submit: () => {
          delFiles(this)
        },
        cancel: () => {
        },
        submitText: '确定删除',
        cancelText: '取消'
      })
    },
    // 寻找已选择的 行
    findSelectItems () {
      let nowItem = null
      let count = 0
      let dataList = [...this.dataList]
      deleteFileList = []
      dataList.map(item => {
        if (item.checked) {
          count++
          nowItem = item
          deleteFileList.push(item)
        }
      })
      if (count > 1) {
        nowItem = null
      }
      return nowItem
    },
    // 下载单文件
    async downloadFile (item) {
      const { suffix, fileId, folder, length } = item

      // if (this.tabletype !== 'personalList'){
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     // 埋点：下载失败
      //     this.sentLog(100112035, {files: [{suffix, fileId, length, status: 0}], code: 402})
      //     return false
      //   }
      // }
      if (folder) {
        this.downLoadFiles([item])
        return
      }
      let path = item.path
      path = encodeURIComponent(path)
      let token = getCookie('ZJYTOKEN')
      let workspaceId = getWorkspaceId(this)
      // 备案库下载单文件
      if (this.isRecord) {
        window.common.downloadFile(
          `${backendUrl}/projects/recorded/file/download?path=${path}&token=${token}&projectId=${this.$route.params.id}`
        )
        return
      }
      if (!item.permission) {
        if (this.tabletype === 'companyList') {
          // 员工 无权下载 企业空间文件
          this.$confirm({
            message: '您没有企业空间权限，请联系管理员获取权限。',
            tips: '管理员账号为：' + this.user.adminAccount,
            type: 'noPermission',
            width: 420,
            cancel: () => {
              this.$store.commit('user/SET_TO_LOGIN_AS_ADMIN')
            },
            submitText: '确定',
            cancelText: '我是管理员'
          })
        }
        // 埋点：下载失败
        this.sentLog(100112035, {files: [{suffix, fileId, length, status: 0}], code: 403})
        return
      }
      // 记录操作
      // this.recordsDataOpration(1, item);
      this.addOperationRecords(1, item)
      this.getFilePrivilege(item.fileId).then(res => {
        if (res.code === 200) {
          if (res.data.privilege === 'view'){
            this.msg = {
              type: '下载',
              show: true,
              isShort: true,
              arr: [item.name]
            }
          } else {
            // 埋点：下载成功
            this.sentLog(100112035, {files: [{suffix, fileId, length, status: 1}]})
            window.common.downloadFile(
              `${backendUrl}/file/download?path=${path}&token=${token}&workspaceId=${workspaceId}`
            )
          }
        } else {
          // 埋点：下载失败
          this.sentLog(100112035, {files: [{suffix, fileId, status: 0}], code: res.code})
          this.$message.error(res.message ? res.message : '获取对该文件夹权限失败！')
        }
      })
    },
    // 下载多文件
    async downLoadFiles (downItems) {

      let list = downItems || this.dataList.filter(item => item.checked)
      if (list.length === 0) {
        return
      }
      let logData = {
        extJson: {
          files: list.map(item => {
            return {
              length: item.length,
              fileId: item.fileId,
              suffix: item.suffix,
              status: 0
            }
          }),
          count: list.length
        }
      }
      if (this.contextMenuShow) {
        logData.fnCode = 100112036
        // this.sentLog(100112036)
      } else {
        logData.fnCode = 100112034
        // this.sentLog(100112034)
      }
      // if (this.tabletype !== 'personalList'){
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: 402}))
      //     return false
      //   }
      // }
      let filePathListm = []
      let folderPathList = []
      let workspaceId = getWorkspaceId(this)
      list.map(item => {
        if (item.folder) {
          folderPathList.push(item.path)
        } else {
          filePathListm.push(item.path)
        }
      })
      let parameter = {
        filePathListm,
        folderPathList,
        workspaceId,
        projectId: this.$route.params.id
      }
      this.contextMenuShow = false
      // 备案库下载多个文件
      if (this.isRecord) {
        SpaceService.downloadFiles(parameter).then(res => {
          if (+res.code === 200) {
            // 记录操作-下载
            this.addOperationRecords(1, list)
            if (res.data && res.data.failture && res.data.failture.length > 0) {
              this.msg = {
                type: '下载',
                show: true,
                isShort: true,
                arr: res.data.failture
              }
            }
            if (res.data.dataUrl) {
              this.downloadProgressLaterShow = true
              getDownloadFilesState(this, res.data.dataUrl, {logData})
            } else {
              this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
              this.$message.warning('文件夹是空')
            }
          } else if (+res.code === 403) {
            this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
            this.$message.error(res.message ? res.message : '下载失败！')
          }
        })
        return
      }
      // 共享空间是否有下载权限
      if (this.tabletype === 'companyList' && +this.user.userType !== 1) {
        let beDownLoad = true
        list.map(item => {
          if (!item.permission && !item.folder) {
            beDownLoad = false
          }
        })
        if (!beDownLoad) {
          // 没有权限提示
          this.$confirm({
            message:
                list.length === 1
                  ? '您没有企业空间权限，请联系管理员获取权限。'
                  : '部分工程需要企业空间权限，请联系管理员获取权限。',
            tips: '管理员账号为：' + this.user.adminAccount,
            type: 'noPermission',
            width: 420,
            cancel: () => {
              this.$store.commit('user/SET_TO_LOGIN_AS_ADMIN')
            },
            submitText: '确定',
            cancelText: '我是管理员'
          })
          return
        }
      }
      SpaceService.downloadFiles(parameter).then(res => {
        if (+res.code === 200) {
          // 记录操作-下载
          // this.recordsDataOpration(1, list);failture
          this.addOperationRecords(1, list)
          if (res.data && res.data.failture && res.data.failture.length > 0) {
            this.msg = {
              type: '下载',
              show: true,
              isShort: true,
              arr: res.data.failture
            }
          }
          if (res.data.dataUrl) {
            this.downloadProgressLaterShow = true
            getDownloadFilesState(this, res.data.dataUrl, {logData})
          } else {
            this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
            this.$message.warning('文件夹是空')
          }
        // } else if (+res.code === 403) {
        } else {
          this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
          this.$message.error(res.message ? res.message : '下载失败！')
        }
      })
    },
    // 右键菜单 重命名 点击
    contextMenuFileRename () {
      if (this.contextMenuDisable.rename) {
        return
      }
      this.dataList.map((item, index) => {
        if (item.checked) {
          this.fileRename(index, item.name, 'contextmenu', item)
        }
      })
    },
    // 重命名
    fileRename (index, name, actionType, item) {
      if (!this.nameCanClick(item)) {
        return false
      }
      // 双击 备案列表 不重命名
      if (this.isRecord) {
        this.nameClick(item)
        return
      }
      // 双击GTJXT文件无反应
      if (item && this.isGTJXT(item)) {
        this.gtjxt = true
        this.nameClick(item)
        return
      }
      let value = name
      let suffix = ''
      if (!item.folder) {
        value = name.substring(0, name.lastIndexOf('.'))
        suffix = name.substring(name.lastIndexOf('.') + 1)
      }
      clearTimeout(nameClickTimer)
      this.renameData = {
        suffix,
        value,
        showIndex: index
      }
      this.contextMenuShow = false
      if (this.isRaname) {
        setTimeout(() => {
          let queryinput = document.querySelector('.renameInput')
          queryinput.setSelectionRange(0, name.length)
          queryinput.focus()
        }, 200)
        return
      } else {
        this.isRaname = true
      }

      setTimeout(() => {
        let queryinput = document.querySelector('.renameInput')
        queryinput.setSelectionRange(0, name.length)
        queryinput.focus()
      }, 200)
    },
    // 重命名确定
    fileRenameSuccess (item) {
      let name = this.renameData.value.replace(/^\s*|\s*$/g, '')
      let reg = /^(?!\.)(?!com[0-9]\$)(?!con\$)(?!lpt[0-9]\$)(?!nul$)(?!prn\$)[^\|\*\"\?\\:<>\$]*[^\/\.\|\*\?\"\\:<>\$]+$/
      if (name === '') {
        this.$message.info('文件名不能为空')
        return
      }
      if (!reg.test(name)) {
        this.$message.warning(
          '文件名不能包含下列任何字符：\\ / : * ? " < > $ |  并且不能以 . 开头和结尾'
        )
        return
      }
      if (name.length > 83) {
        this.$message.warning('文件名字长度应该不超过83个字符长度 ')
        return
      }
      if (!item.isCreateFolder) {
        // 修改名称
        let parameter = {
          newName:
              name +
              (this.renameData.suffix
                ? '.' + this.renameData.suffix
                : this.renameData.suffix),
          path: item.path,
          workspaceId: getWorkspaceId(this)
        }
        if (parameter.newName === item.name) {
          this.fileRenameCancel()
          return
        }
        // 防止多次点击
        if (this.renameOk) {
          return
        } else {
          this.renameOk = true
        }
        SpaceService.putFileRename(parameter).then(res => {
          this.isRaname = false
          this.renameOk = false
          if (+res.code === 200) {
            // 操作记录-重命名
            item.path = item.path + '->' + parameter.newName
            // this.recordsDataOpration(6, item);
            this.addOperationRecords(6, item)
            initData(this)

          } else if (+res.code === 270014) {
            if (res.data[0].filePath === res.data[0].lockUsers[0].filePath) {
              this.$confirm({
                message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
                    (res.data[0].lockUsers[0].lockUserName
                      ? res.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (res.data[0].filePath.indexOf(res.data[0].lockUsers[0].filePath) !== -1) {
              const projectname = res.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
                    projectname +
                    "）</em>正在被<em style='color: #1c6ccd;'>" +
                    (res.data[0].lockUsers[0].lockUserName
                      ? res.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (res.data[0].lockUsers[0].filePath.indexOf(res.data[0].filePath) !== -1) {
              const projectname = res.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
                    projectname +
                    "）</em>正在被<em style='color: #1c6ccd;'>" +
                    (res.data[0].lockUsers[0].lockUserName
                      ? res.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            }
          } else {
            this.$message.error(res && res.message ? res.message : '修改失败！')
          }
        }).catch((e) => {
          this.$message.error('修改失败')
          this.isRaname = false
          this.renameOk = false
        })
      } else {
        // 防止多次点击
        if (this.renameOk) {
          return
        } else {
          this.renameOk = true
        }
        // 创建文件验证
        let path = this.path === '/' ? '' : this.path
        let parameter = {
          path: path + '/' + this.renameData.value,
          workspaceId: getWorkspaceId(this)
        }
        SpaceService.createFolder(parameter).then(res => {
          if (+res.code === 200) {
            this.isRaname = false
            this.renameOk = false
            initData(this)
          } else {
            this.$message.error(res.message ? res.message : '创建文件夹失败！')
            this.renameOk = false
            this.isRaname = false
          }
        }).catch(() => {
          this.$message.error('创建文件夹失败！')
          this.isRaname = false
          this.renameOk = false
        })
      }
    },
    handleRenameBlur (item) {
      if (this.renameData.value.trim() !== '') {
        this.fileRenameSuccess(item)
      } else {
        this.fileRenameCancel(item)
      }
    },
    // 重命名取消
    fileRenameCancel (item) {
      const showIndex = this.renameData.showIndex
      this.isRaname = false
      this.renameData = {
        suffix: '',
        value: '',
        showIndex: -1
      }
      this.renameOk = false
      if (item) {
        if (item.isCreateFolder) {
          let datalist = JSON.parse(JSON.stringify(this.dataList))
          if (showIndex === 1) {
            datalist.splice(1, 1)
          } else {
            // datalist = datalist.splice(1);
            datalist.shift()
          }
          this.dataList = datalist
        } else {
        }
      }
    },
    // 打开GCCP6
    async openGCCP6 (action = 'open', path = '') {
      try {
        let gccsToken = this.gccsToken
        if (!gccsToken) {
          const { code, data = {}, message = '获取gccsToken失败，请稍后重试' } = await r2Project.getGCCSToken()
          const token = data.gccsToken
          if (code === 200 && token) {
            // setCookie('gccsToken', token)
            gccsToken = token
            this.gccsToken = token
          } else {
            this.$message.error(message)
            return
          }
        }
        const account = this.user.userName || getCookie('ZJYACCOUNT')
        if (!account) {
          this.$message.error('未检测到用户信息，请重新登录后再试')
          return
        }
        const loading = this.$loading({
          background: 'rgba(0, 0, 0, 0.3)',
          text: '检测中...'
        })
        if (action === 'create') {
          this.pathItems.forEach(item => {
            if (item.filePath) {
              path = `${item.filePath}/`
            }
          })
        }
        openIPC({
          path: encodeURIComponent(`/项目空间${path}`),
          gccsToken,
          account,
          action
        }).then(() => {
          this.sentLog(action === 'open' ? 100112059 : 100112058, {status: 1})
          loading.close()
        }).catch(() => {
          this.sentLog(action === 'open' ? 100112059 : 100112058, {status: 0})
          loading.close()
          this.$confirm({
            boxId: 'gsscp6Uninstall',
            message: '您的计算机未安装GCCP6软件，请先安装后，再使用此功能。',
            width: 400,
            type: 'warning',
            submitText: '去下载',
            cancelText: '取消',
            submit: () => {
              window.open('https://www.fwxgx.com/softwares/list/304')
            }
          })
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    // 预览限制暂时不支持的文件
    previewData (item, icon, type){
      this.sentLog(100112041, {files: [{suffix: icon.suffix, fileId: item.fileId, status: 1, length: item.length}], status: 1, length: item.length})
      // let iconUpperCase = icon.suffix.toUpperCase()


      // if (/\/database\/data\/record\//.test(window.location.href) && unsuportfiles.indexOf(iconUpperCase) > -1){
      //   this.$message.warning('备案库预览功能正在研发中，敬请期待')
      //   return
      // }
      //
      //
      // let suffixArr = ['gtj', 'gtjxt', 'gdq', 'gqi4']
      if (this.isRecord) {
        r2Project.getRecordedUploadUrl().then(res => {
          const {code, data} = res
          const { recordWorkspaceId } = data || {}
          if (code === 200 && recordWorkspaceId) {
            console.log(this.$route.params.id)
            this.filePreview(item, icon, type, {
              moduleName: 'recordList',
              recordWorkspaceId,
              isRecord: true,
              projectId: this.$route.params.id
            })
          } else {
            this.$message.error('获取备案库空间ID失败，请稍后重试')
          }
        })
      } else {
        this.preview(item, icon, type)
      }
    },
    // gjtxt 模型浏览
    previewgtjxt (item) {
      // gjtxt 模型浏览埋点
      // let projectid = this.$route.params.id
      // let prjname = this.prjName
      // this._sendIOLog('查看模型', 'web端', '10062', '-102019', '2', projectid, prjname)
      // gjtxt 模型浏览
      this.previewData(item, this.previewIcon[this.capitalize('gtj')], 2)
    },
    // 单机，双击事件拦截
    nameCanClick (item) {
      try {
        if (this.isPricingCollaboration && item.fileProperties.coProjectId) {
          return false
        }
        return true
      } catch (e) {
        return false
      }
    },
    // 名称点击
    nameClick (item) {
      if (!this.nameCanClick(item)) {
        return false
      }
      this.contextMenuShow = false
      if (this.loading) return
      // 进入文件夹
      clearTimeout(nameClickTimer)
      // gtjxt 双击不触发点击
      if (this.gtjxt) {
        this.gtjxt = false
        return
      }
      nameClickTimer = setTimeout(() => {
        if (item.folder) {
          if (this.isRecord) {
            this.path = item.path
            this.dataList = []
            this.pathItems.push({
              name: item.name,
              filePath: item.path,
              fileId: item.fileId
            })
            initData(this)
          } else {
            this.getFilePrivilege(item.fileId).then((res) => {
              if (res.code === 200) {
                this.path = item.path
                this.dataList = []
                this.pathItems.push({
                  name: item.name,
                  filePath: item.path,
                  fileId: item.fileId
                })
                this.filePrivilege = res.data.privilege
                initData(this)
              } else {
                this.dataList = []
                this.$message.error(res.message ? res.message : '获取对该文件夹权限失败！')
              }
            })
          }
        } else {
          // 如果是GTJXT
          if (this.isGTJXT(item)) {
            this.previewData(item, this.previewIcon[this.capitalize('gtj')], 1)
            // let projectid = this.$route.params.id
            // let prjname = this.prjName
            // this._sendIOLog('查看模型', 'web端', '10062', '-102019', '2', projectid, prjname)
            return
          }
          if (
            this.iconListKey &&
              this.previewIcon[this.capitalize(item.suffix)] &&
              this.previewIcon[this.capitalize(item.suffix)].suffix
          ) {
            // 我收到的分享工程列表 内 文件名称 或 icon点击 执行预览
            this.previewData(item, this.previewIcon[this.capitalize(item.suffix)], 1)
          }
        }
      }, 300)
    },
    // 顶部按钮点击
    topButtonClick (type, e) {
      if (type === 'addFolder') {
        createdFolder(this)
        this.sentLog(100112030)
      } else if (type === 'refresh') {
        initData(this)
      } else if (type === 'delete') {
        this.deleteFiles()
      } else if (type === 'download') {
        this.downLoadFiles()
      } else if (type === 'move') {
        this.moveFilesTap(true)
      } else if (type === 'openGCCP6') {
        this.openGCCP6('create', `/${this.prjName}/`)
      }
    },
    getPathNameG () {
      let name = '全部文件'
      if (+this.fileType === 1) {
        name = '计价文件'
      }
      if (+this.fileType === 2) {
        name = '计量文件'
      }
      return name
    },
    // 面包屑点击
    queryPathList (data) {
      this.fileSearch = ''
      this.searchVal = ''
      // debugger
      if (data.items.length === 1) { // "全部文件"
        this.path = '/'
        this.pathItems = [{name: `${this.getPathNameG()}`}]
        this.filePrivilege = 'delete'
        initData(this)
      } else {
        this.pathItems = data.items
        let fileId = data.items[data.items.length - 1].fileId
        let filePath = data.items[data.items.length - 1].filePath
        if (!this.allFiles && filePath) {
          this.path = data.items[data.items.length - 1].filePath
        } else if (this.path.indexOf('/' + this.prjName) === 0) {
          if (+this.prjType === 1 && this.activeTab && +this.tabType === 1){
            this.path = '/' + this.prjName + '/' + this.activeTab + data.filepath
          } else {
            this.path = '/' + this.prjName + data.filepath
          }
        } else {
          this.path = data.filepath
        }
        if (fileId && !this.isRecord){
          this.getFilePrivilege(fileId).then((res) => {
            if (res.code === 200) {
              this.dataList = []
              this.filePrivilege = res.data.privilege
              initData(this)
            } else {
              this.dataList = []
              this.loading = false
              this.$message.error(res.message ? res.message : '获取对该文件夹权限失败！')
            }
          })
        } else {
          this.filePrivilege = 'delete'
          initData(this)
        }
      }
    },
    // 获取列表是图片模式还是列表模式
    getTypeFilterData () {
      if (this.tabletype === 'personalList') {
        this.typeFilterData = this.personalFilter.listType
      }
      if (this.tabletype === 'companyList') {
        this.typeFilterData = this.enterpriseFilter.listType
      }
      if (this.tabletype === 'projectList') {
        this.typeFilterData = this.projectFilter.listType
      }
    },
    // 列表类型切换
    typeQueryList (data) {
      // this.searchVal = ''
      // this.fileSearch = ''
      // this.pathItems = [{name: `${this.getPathNameG()}`}]
      this.fileType = 0
      this.filePrivilege = 'delete'
      this.$forceUpdate()
      this.lock = false
      this.path = '/'
      this.$nextTick(() => {
        this.$refs.userNameInput.focus()
      })
      // if (+data === 0) {
      //   this.$parent.setTab('10')
      // } else {
      //   this.$parent.searchAll = false
      //   this.$parent.setTab(this.$parent.defaultTab)
      // }
    },
    // 列表图片切换
    moduleTypeQueryList () {
      if (this.typeFilterData === 'list') {
        this.typeFilterData = 'thumbnail'
      } else {
        this.typeFilterData = 'list'
      }
      let typeFilterData = {...this.projectFilter}
      typeFilterData.listType = this.typeFilterData
      this.setProjectTypeFilter(typeFilterData)
      initData(this)
    },
    // 校验容量
    checkCapacity (fileSize) {
      return new Promise((resolve, reject) => {
        let workspaceId = getCookie('enterpriseWorkspaceIdValue')
        fileSize = fileSize || 0
        SpaceService.getWorkspaceById({workspaceId}).then(data => {
          if (+data.code === 200) {
            let {totalCapacity, usedCapacity} = data.data
            usedCapacity = usedCapacity || 0
            totalCapacity = totalCapacity || 0
            if (
              parseInt(totalCapacity) >
                parseInt(usedCapacity) + parseInt(fileSize)
            ) {
              resolve()
            } else {
              this.$message.info('企业共享空间容量不足，请您联系管理员进行扩容')
              reject(new Error('error log'))
            }
          }
        })
      })
    },
    // 拷贝
    fileCopy (operationType) {
      const ZJYTOKEN = getCookie('ZJYTOKEN')
      let sourceFileList = []
      let sourceFolderList = []
      let filesize = 0
      copyFilesPath.map(item => {
        if (item.folder) {
          sourceFolderList.push(item.path)
        } else {
          if (item.length) {
            filesize = filesize + parseInt(item.length)
          }
          sourceFileList.push(item.path)
        }
      })
      this.checkCapacity(filesize).then(() => {
        const cacheKey = new Date().getTime() + '_' + ZJYTOKEN
        let parameter = {
          cacheKey,
          operationType: operationType || 1,
          paramType: 'filePath',
          sourceWorkspaceId: getWorkspaceId(this),
          targetFile: '/',
          targetWorkspaceId: getWorkspaceIdByType('company'),
          sourceFileList: sourceFileList,
          sourceFolderList: sourceFolderList
        }
        let taskComplete = 0
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
              this.$message.success('已成功复制到共享空间')
              initData(this)
            } else {
              this.$message.error('复制到共享空间失败')
            }
            this.topButtonClick('refresh')
          }
        }
        SpaceService.fileCopy(parameter).then(res => {
          result = res
          afterTask()
        })
        this.getProgress('copy', '', 'COPY_FLAG_' + cacheKey, true).then(({hit}) => {
          taskComplete = hit
          afterTask()
        })
      })
    },
    // 多文件移动到点击
    moveFilesTap (isContext = false) {
      if (this.contextMenuDisable.move || !this.allFiles) {
        return
      }
      if (isContext) {
        this.sentLog(100112031, {count: this.checkedLen})
      } else {
        this.sentLog(100112032)
      }
      this.contextMenuShow = false
      moveFilesPath = this.dataList.filter(item => item.checked)
      this.moveLayerShow = true
    },
    // 单文件移动到点击
    moveFileTap (item) {
      moveFilesPath = [item]
      this.moveLayerShow = true
    },
    // 移动到确定
    moveAffirm (val) {
      this.moveLayerShow = false
      if (val === this.path && !this.searchVal) {
        this.$message.error('移动失败')
        return
      }
      this.fileMoveExist(val)
    },
    // 移动到验证
    fileMoveExist (parentPath) {
      const filePathList = []
      const folderPathList = []
      // let sourceParentPath = '/';
      moveFilesPath.forEach((item) => {
        let path = item.path
        // path = path.replace(/^\/+/, '')
        if (item.folder) {
          folderPathList.push(path)
        } else {
          filePathList.push(path)
        }
      })
      const parameter = {
        filePathList,
        folderPathList,
        // sourceParentPath,
        targetPath: parentPath,
        sourceWorkspaceId: getWorkspaceId(this),
        targetWorkspaceId: getWorkspaceId(this)
      }
      SpaceService.fileExist(parameter).then(res => {
        if (+res.code === 200) {
          if ((res.data.sameNameFiles && res.data.sameNameFiles.length > 0)) {
            this.replaceFileHintShow = parentPath
          } else {
            this.fileMove(parentPath)
          }
        } else {
          this.$message.error(res.message || '移动失败！')
        }
      }).catch((e) => {
      })
    },
    // 文件替换提示click
    replaceFileHintBtnClick (val) {
      if (val === 'close') {
        this.replaceFileHintShow = false
        return
      }
      let value = this.replaceFileHintShow
      this.fileMove(value, val)
      this.replaceFileHintShow = false
    },
    // 移动到
    fileMove (val, operationType) {
      const ZJYTOKEN = getCookie('ZJYTOKEN')
      let sourceFileList = []
      let sourceFolderList = []
      moveFilesPath.map(item => {
        if (item.folder) {
          sourceFolderList.push(item.path)
        } else {
          sourceFileList.push(item.path)
        }
      })
      if (sourceFolderList.includes(val)) {
        this.$message.error('移动失败！')
        return
      }
      // 过滤父文件移动到子文件中
      let isSubToSup = false
      sourceFolderList.map((item) => {
        let nowItem = item + '/'
        nowItem = nowItem.replace(/[/]{2,}/g, '/')
        if (val.indexOf(nowItem) > -1) {
          isSubToSup = true
        }
      })
      if (isSubToSup) {
        this.$message.error('移动失败！')
        return
      }
      const cacheKey = new Date().getTime() + '_' + ZJYTOKEN
      let parameter = {
        cacheKey,
        operationType: operationType || 1,
        paramType: 'filePath',
        projectId: this.$route.params.id,
        sourceWorkspaceId: getWorkspaceId(this),
        targetFile: val,
        targetWorkspaceId: getWorkspaceId(this),
        sourceFileList: sourceFileList,
        sourceFolderList: sourceFolderList
      }

      let taskComplete = 0
      let result = null
      const afterTask = () => {
        if (taskComplete && result) {
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
            // 操作记录
            // this.recordsDataOpration(7, moveFilesPath);
            this.$message.success('移动成功')
            this.addOperationRecords(7, moveFilesPath)
            initData(this)
          } else if (+result.code === 270014) {
            if (result.data[0].filePath === result.data[0].lockUsers[0].filePath) {
              this.$confirm({
                message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
                    (result.data[0].lockUsers[0].lockUserName
                      ? result.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (result.data[0].filePath.indexOf(result.data[0].lockUsers[0].filePath) !== -1) {
              const projectname = result.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
                    projectname +
                    "）</em>正在被<em style='color: #1c6ccd;'>" +
                    (result.data[0].lockUsers[0].lockUserName
                      ? result.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (result.data[0].lockUsers[0].filePath.indexOf(result.data[0].filePath) !== -1) {
              const projectname = result.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
                    projectname +
                    "）</em>正在被<em style='color: #1c6ccd;'>" +
                    (result.data[0].lockUsers[0].lockUserName
                      ? result.data[0].lockUsers[0].lockUserName
                      : '其他') +
                    '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            }
          } else {
            this.$message.error('移动失败')
          }
          this.topButtonClick('refresh')
        }
      }
      SpaceService.fileMove(parameter).then(res => {
        if (res.code === 403) {
          if (window.moveProgressTimerEmitter){ clearTimeout(window.moveProgressTimerEmitter) }
          if (window.moveProgressTimer) {
            clearTimeout(window.moveProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true})
          setTimeout(() => {
            this.$confirm({
              type: 'noPermission',
              imageSrc: this.bimFaceError,
              message: `因权限问题，无法向${parameter.targetFile.slice(parameter.targetFile.lastIndexOf('/') + 1)}中移动文件`,
              imageWidth: 140, // 图片宽度
              width: 360, // 弹窗宽度
              submit: (data) => {
                console.log(data)
              },
              noCancelBtn: true
            })
          }, 2000)
          return
        }
        if (res.data && res.data && res.data.length > 0) {
          this.msg = {
            type: '移动',
            show: true,
            isShort: true,
            arr: res.data
          }
        }
        if (res.data.length !== (sourceFolderList.length + sourceFileList.length)){
          result = res
          afterTask()
        }
      })
      this.getProgress('move', 1, 'MOVE_FLAG_' + cacheKey, true).then(({hit}) => {
        taskComplete = hit
        afterTask()
      })
    },
    // 移动到取消
    moveCancel () {
      this.moveLayerShow = false
    },
    // 上传
    upload (type) {
      const pathItems = this.pathItems.map((item, index) => {
        return ((index === 0 && item.name !== '全部文件') || index > 0 ? item.name : '')
      }).join('/')
      const filePath = `/${this.prjName}/${this.prjType === 1 ? this.activeTab : ''}${pathItems}`
      Bus.$emit('openUploader', {
        type: type,
        parameter: {
          workspaceId: getWorkspaceId(this),
          filePath
          // filePath: this.path
        },
        nowPage: 'enterprise',
        moduleName: '工程文件',
        isDataModule: false,
        needRecord: true
      })
    },
    // 搜索
    searchHandle: _.debounce(function (obj){
      this.$refs.userNameInput.blur()
      if ((this.searchVal === '' && this.fileSearch === '') || (this.tabType === 0 && this.fileSearch === '')) {
        return
      }
      this.sentLog(this.isRecord ? 100112064 : 100112040, {message: this.fileSearch})
      this.searchVal = this.fileSearch
      initData(this, false, true)
    }, 10),
    // 处理文件类型
    getFileTypeHandle (proT) {
      let extraInfo, extraInfoStr
      if (proT >= 4000) {
        extraInfo = 4
        extraInfoStr = '审核'
      } else if (proT >= 3000) {
        extraInfo = 3
        extraInfoStr = '结算'
      } else if (proT >= 2000) {
        extraInfo = 2
        extraInfoStr = '预算'
      } else if (proT >= 1000) {
        extraInfo = 1
        extraInfoStr = '概算'
      } else {
        extraInfo = 0
        extraInfoStr = '其它'
      }
      return {
        extraInfo,
        extraInfoStr
      }
    },
    // 获取类型
    getFileTypeName (item) {
      if (+item.fileType === 1) {
        return '计价'
      }
      if (+item.fileType === 2) {
        return '计量'
      }
      if (+item.fileType === 3) {
        return '计量协同'
      }
      return '无'
    },
    // 判断 查看模型、预览 操作是否可用
    judgePreview () {
      const item = this.dataList[trIsMouseEnter]
      const nowIcon = this.previewIcon[this.capitalize(item.suffix)]
      if (this.isGTJXT(item)) {
        this.nowPreview.item = item
        this.nowPreview.icon = nowIcon
        return
      } else {
        this.nowPreview.item = item
      }
      let checkedLen = this.dataList.filter(item => {
        return item.checked
      }).length
      if (checkedLen > 1) {
        this.contextMenuDisable.viewModel = true
        this.contextMenuDisable.preview = true
        return
      }
      this.contextMenuDisable.viewModel = true
      this.contextMenuDisable.preview = true
      this.nowPreview.index = trIsMouseEnter
      this.nowPreview.item = {}
      this.nowPreview.icon = {}
      if (nowIcon && nowIcon.suffix) {
        switch (nowIcon.suffix) {
          case 'gtj':
          case 'gtjxt':
          case 'gtjjy':
          case 'gtjxs':
          case 'gdq':
          case 'gqi4':
          case 'gqijy':
          case 'gqixs':
            this.contextMenuDisable.viewModel = false
            break
          default:
            this.contextMenuDisable.preview = false
        }
        this.nowPreview.item = item
        this.nowPreview.icon = nowIcon
      }
    },
    // 图标hover
    personTextBoxStyleHandle (index) {
      handelTextBoxStyle(this)
      this.iconHoverIndex = index
    },
    // 8. 右键菜单 某一操作项 点击
    contextmenuClick (type) {
      const {length, fileId, suffix, path} = this.nowPreview.item
      switch (type) {
        case 'gtjxtmodel':
          if (!this.contextMenuDisable[type]) {
            this.contextMenuShow = false
            this.goGTJXTModel(this.nowPreview.item, true)
          }
          this.sentLog(100112041, {files: [{fileId, suffix, length, status: 1}], length, status: 1})
          break
        case 'preview':
          if (!this.contextMenuDisable[type]) {
            this.contextMenuShow = false
            this.previewData(this.nowPreview.item, this.nowPreview.icon, 3)
          }
          this.sentLog(100112041, {files: [{fileId, suffix, length, status: 1}], length, status: 1})
          break
        case 'viewModel':
          let item = this.nowPreview.item
          if (item.icons && item.icons && item.icons.toUpperCase() === 'GTJXT') {
            this.previewData(item, this.previewIcon['gtj'], 3)
          } else if (!this.contextMenuDisable[type]) {
            this.contextMenuShow = false
            this.previewData(this.nowPreview.item, this.nowPreview.icon, 3)
          }
          this.sentLog(100112041, {files: [{fileId, suffix, length, status: 1}], length, status: 1})
          break
        case 'rename':
          this.fileRename(this.nowPreview.index, this.nowPreview.item.name)
          break
        case 'delete':
          break
        case 'openGCCP6':
          this.openGCCP6('open', path)
          break
        default:
      }
    },
    // 9. 右键菜单 状态设置
    setContextMenuStatus () {
      // 文件夹权限
      if (this.filePrivilege === 'view') { // 查看权限
        this.contextMenuDisable = {
          viewModel: true,
          preview: true,
          download: true,
          delete: true,
          move: true,
          rename: true,
          copy: true
        }
      } else if (this.filePrivilege === 'update') { // 编辑权限
        if (this.checkedLen > 1) {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: true,
            move: true,
            rename: true,
            copy: false
          }
        } else {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: true,
            move: true,
            rename: false,
            copy: false
          }
        }
      } else if (this.filePrivilege === 'delete' || this.filePrivilege === 'grant') { // 管理权限
        if (this.checkedLen > 1) {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: false,
            move: false,
            rename: true,
            copy: false
          }
        } else {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: false,
            move: false,
            rename: false,
            copy: false
          }
        }
      } else { // 无权限
      }
    },
    // 10. 设置右键菜单列表状态 和 顶部操作按钮组
    setContextmenuStatusAndTopButtons () {
      this.checkedLen = this.dataList.filter(item => {
        return item.checked
      }).length
      // 设置 右键菜单列表 置灰状态
      this.setContextMenuStatus()
      // 设置 顶部操作按钮组
      // 备案库
      if (this.isRecord) {
        if (this.checkedLen > 0 && (this.prjRole === 1 || this.isCompanyAdmin || this.isModuleView)) {
          this.buttonList = ['download']
        } else {
          this.buttonList = []
        }
        return
      }

      if (+this.tabType === 0 || !this.activeTab){
        if (this.checkedLen > 0){
          this.buttonList = ['refresh', 'download', 'delete']
        } else {
          this.buttonList = ['refresh']
        }
      } else {
        if (this.checkedLen > 0) {
          this.buttonList = ['upload', 'addFolder', 'refresh', 'download', 'delete', 'move']
          if (!this.isCompanyAdmin && this.prjRole === 4){ // 非项目成员
            this.buttonList = ['refresh', 'download']
          }
        } else {
          this.buttonList = ['upload', 'addFolder', 'refresh']
          if (!this.isCompanyAdmin && this.prjRole === 4){ // 非项目成员
            this.buttonList = ['refresh', 'download']
          }
        }
      }
      // 列表展示 搜索出来的文件时 去掉 新建文件夹 按钮
      if (this.searchVal) {
        if (this.buttonList.indexOf('addFolder') > -1) {
          this.buttonList.splice(this.buttonList.indexOf('addFolder'), 1)
        }
      }
      // 文件夹权限
      if (this.filePrivilege === 'update') { // 编辑权限
        if (this.buttonList.indexOf('delete') > -1) {
          this.buttonList.splice(this.buttonList.indexOf('delete'), 1)
        }
        if (this.buttonList.indexOf('move') > -1) {
          this.buttonList.splice(this.buttonList.indexOf('move'), 1)
        }
      } else if (this.filePrivilege === 'view') { // 查看权限
        this.buttonList = ['refresh']
      } else if (this.filePrivilege === 'delete' || this.filePrivilege === 'grant') { // 管理权限

      } else { // 无权限
        this.buttonList = []
      }
      // 计价协同项目，顶部固定按钮（上传，新建文件夹，新建计价工程，刷新）,搜索后，去掉新建文件夹按钮
      if (this.isPricingCollaboration) {
        // const buttonList = ['upload', 'openGCCP6', 'refresh']
        // !this.searchVal && buttonList.splice(0, 0, 'addFolder')
        // this.buttonList = buttonList
        this.buttonList = ['refresh'] // 2022.12.6宋佳龙邮件输入
      }
    },
    // 12.1 获取文件夹权限
    getFilePrivilege (id) {
      let params = {
        fileId: id,
        workspaceId: getCookie('projectWorkspaceIdValue')
      }
      return r2Project.getFilePrivilege(params)
    },
    // 12.2 获取阶段文件夹Id
    getFileId (){
      this.setRoot(null)
      if (+this.prjType === 1){
        let parameter = {
          path: '/' + this.prjName,
          workspaceId: getCookie('projectWorkspaceIdValue'),
          fileType: 0,
          sortFieldName: 'modifiedTime',
          sortType: 1,
          pageNum: 1,
          pageSize: 10,
          projectId: this.$route.params.id
        }
        this.rootFile = {}
        SpaceService.getFileList(parameter).then(res => {
          if (res.code === 200){
            res.data.items.map(items => {
              this.rootFile[items.name] = items.fileId
            })
            this.setRoot(this.rootFile)
          }
        })
      }
    },
    // 二次验证---关闭
    verifyClose (){

    },
    // 点击进入所在目录
    handleDirectoryClick (item) {
      // this.fileSearch = ''
      // this.searchVal = ''
      const {fileId, path} = item
      const params = {
        fileId,
        projectStage: this.activeTab,
        filePath: path.substring(0, path.lastIndexOf('/')),
        spaceType: 3,
        path: this.$route.path
      }
      if (!this.isRecord) {
        params.workspaceId = getWorkspaceId(this)
      }
      this.directoryJump(params).then(() => {
        this.fileSearch = ''
        this.searchVal = ''
        if (this.prjType === 1) {
          const paths = path.split('/')
          if (this.activeTab === paths[2]) {
            initData(this)
          }
          Bus.$emit('setTabActive', paths[2])
        } else {
          initData(this)
        }
      })
    }
  },
  beforeDestroy () {
    Bus.$off('SpaceFileListReload')
    initEvent(this)
    window.privilege = undefined
    window.recordedProjectId = undefined
  },
  mounted () {
    let _self = this
    Bus.$on('SpaceFileListReload', query => {
      try {
        let pathArr = decodeURIComponent(query).split('/')
        // 更新状态
        if (_self.prjName === pathArr[1] && _self.$parent.prjStatus.prjStatus[pathArr[2]] === 0){
          _self.$parent.prjStatus.prjStatus[pathArr[2]] = 1
        }
      } catch (error) {
        console.log(error)
      }
      console.log(query)
      initData(_self)
    })
    if (!this.$route.params.status) {
      this.tabType = 0
      this.$parent.searchAll = true
    }
    // this.tableHeight = 'auto'
    this.pathItems = [{name: `${this.getPathNameG()}`}]
    window.recordedProjectId = this.isRecord ? this.$route.params.id : ''
    setTimeout(() => {
      this.tableHeight = this.getTableHeight('fileTabId') - 230
    }, 200)
    // 初始化事件
    console.log(`this.prjCategory:${this.prjCategory}`)

  },
  created () {
    this.isCompanyAdmin = this.hasModuleAuth('zjy_module_project_zsxmk_wcyd_manage') || this.hasModuleAuth('zjy_module_project_zsxmk_qbxm_manage') || this.hasModuleAuth('zjy_module_project_baxm_manage')
    this.isModuleView = this.hasModuleAuth('zjy_module_project_zsxmk_wcyd_view') || this.hasModuleAuth('zjy_module_project_zsxmk_qbxm_view') || this.hasModuleAuth('zjy_module_project_baxm_view')
    console.log('当前项目角色', this.prjRole)
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.pathItems[0].name = this.prjName
    // 选定列表类型
    getFileType(this)
    // 初始化事件
    // setTimeout(() => {
    //   initEvent(this, true)
    // }, 100)
    setTimeout(() => {
      initData(this, true)
    }, 500)
    this.getTypeFilterData()
  }
}
const eventList = [
  'keydown',
  'keyup',
  'mousedown',
  'mousemove',
  'mouseup',
  'click',
  'dragleave',
  'dragenter',
  'dragover',
  'drop'
]
const eventObj = {}
eventList.forEach((name) => {
  eventObj[name] = null
})

// 初始化事件
function initEvent (that, init) {
  let _self = that
  // 先销毁事件
  eventList.forEach((name) => {
    if (eventObj[name]) {
      off(document, name, eventObj[name])
      eventObj[name] = null
    }
  })
  if (!init) return
  eventObj.keydown = function (e) {
    if (!_self.isRaname) {
      if (e.keyCode === 16) {
        isOnShift = true
      } else if (e.keyCode === 17) {
        // isOnCtrl = true
      }
    }
  }
  on(document, 'keydown', eventObj.keydown)

  eventObj.keyup = function (e) {
    if (!_self.isRaname) {
      isOnShift = false
      // isOnCtrl = false
    }
  }
  on(document, 'keyup', eventObj.keyup)

  eventObj.mousedown = function (e) {
    // 如果有重命名弹框，取消触发事件
    if (!_self.isRaname) {
      if (trIsMouseEnter > -1) {
        isDownSel = true
        if (mouserEnterItemIndex !== -1) {
          try {
            isDown = _self.dataList[mouserEnterItemIndex].checked
          } catch (error) {
          }
        }
        starX = e.clientX
        starY = e.clientY
      }
    }
    //   isDown = true;
  }
  on(document, 'mousedown', eventObj.mousedown)

  eventObj.mousemove = function (e) {
    // 如果有重命名弹框，取消触发事件
    if (!_self.isRaname && (!_self.isRecord || (_self.isRecord && (_self.prjRole === 1 || _self.isCompanyAdmin)))) {
      e.stopPropagation()
      e.preventDefault()
      if (isDown) {
        if (!isAddBox && (Math.abs(e.clientX - starX) > 10 || Math.abs(e.clientY - starY) > 10)) {
          isAddBox = true
        }
        if (!isAddBox) {
          return
        }
        let mydragIconDom = document.querySelector('.mydrag-icon')
        mydragIconDom.style.left = e.clientX + 10 + 'px'
        mydragIconDom.style.top = e.clientY + 10 + 'px'
        if (_self.allFiles && _self.filePrivilege !== 'view' && _self.filePrivilege !== 'update' && !_self.isRecord) {
          _self.mydragIconShow = true
        }
        if (event.preventDefault) {
          event.preventDefault()
        }
        return false
      } else if (isDownSel) {
        if (!isAddBox && (Math.abs(e.clientX - starX) > 10 || Math.abs(e.clientY - starY) > 10)) {
          isAddBox = true
        }
        if (!isAddBox) {
          return
        }
        if (!_self.mydragSelShow) {
          _self.mydragSelShow = true
          return
        }
        let _x = e.clientX || e.x
        let _y = e.clientY || e.y
        console.log(_y)
        console.log(starY)
        let mydragSel = document.querySelector('.mydrag-sel')
        mydragSel.style.left = Math.min(_x, starX) + 'px'
        mydragSel.style.top = Math.min(_y, starY) + 'px'
        mydragSel.style.width = Math.abs(e.clientX - starX) + 'px'
        mydragSel.style.height = Math.abs(e.clientY - starY) + 'px'

        let _l = mydragSel.offsetLeft
        let _t = that.typeFilterData === 'list' ? mydragSel.offsetTop : mydragSel.offsetTop + 40
        let _w = mydragSel.clientWidth
        let _h = mydragSel.clientHeight

        let projectTabCnt = document.querySelector('#projectTabCnt')
        let tableBodyWrapper = that.typeFilterData === 'list' ? document.getElementsByClassName('prj_scroll-ctx')[0] : document.querySelector('.prj_scroll-ctx')
        let projectTabOffSetLeft = projectTabCnt.offsetLeft
        let tablieBodyScrollTop = tableBodyWrapper
          ? tableBodyWrapper.scrollTop
          : 0
        let projectTabOffSetTop =
            projectTabCnt.offsetTop + 40 - tablieBodyScrollTop
        let trlist = document.querySelectorAll('.trItem')
        for (let i = 0; i < trlist.length; i++) {
          let item = trlist[i]
          let sl = item.clientWidth + item.offsetLeft + projectTabOffSetLeft
          let st = item.clientHeight + item.offsetTop + projectTabOffSetTop
          let dataobj = {..._self.dataList[i]}
          if (sl > _l && st > _t && item.offsetLeft + projectTabOffSetLeft < _l + _w &&
              item.offsetTop + projectTabOffSetTop < _t + _h) {
            if (!dataobj.checked) {
              // GTJXT工程 不可框选
              if (!_self.isGTJXT(dataobj)) {
                dataobj.checked = true
              }
              _self.dataList.splice(i, 1, dataobj)
            }
          } else {
            if (dataobj.checked) {
              dataobj.checked = false
              _self.dataList.splice(i, 1, dataobj)
            }
          }
        }
      }
      _self.$nextTick(() => {
        if (_self.checkedLen === 0) {
          _self.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: true,
            delete: true,
            copyToCompanySpace: true,
            move: true,
            rename: true,
            copy: true,
            noShare: true
          }
        }
      })
    }
  }
  on(document, 'mousemove', eventObj.mousemove)

  eventObj.mouseup = function (e) {
    if (!_self.isRaname) {
      if (isAddBox && trIsMouseEnter > -1) {
        if (_self.dataList[trIsMouseEnter] && !_self.dataList[trIsMouseEnter].checked && _self.dataList[trIsMouseEnter].folder && _self.allFiles && _self.filePrivilege !== 'view' && _self.filePrivilege !== 'update' && !_self.isRecord) {
          // 选择文件 拖拽移动到 “我收到的分享工程” 文件夹时 提示不能移动到此文件夹
          moveFilesPath = _self.dataList.filter(item => item.checked)
          _self.moveAffirm(_self.dataList[trIsMouseEnter].path)
          _self.sentLog(100112033, {count: _self.checkedLen})
        }
      }
      isDown = false
      isDownSel = false
      isAddBox = false
      _self.mydragSelShow = false
      _self.mydragIconShow = false
    }
  }
  on(document, 'mouseup', eventObj.mouseup)

  eventObj.click = function (e) {
    if (!_self.isRaname) {
      if (_self.contextMenuShow) {
        _self.contextMenuShow = false
      }
    }
  }
  on(document, 'click', eventObj.click)

  setTimeout(() => {
    let trlistDom = document.querySelector('#projectTabCnt')
    on(trlistDom, 'contextmenu', function (e) {
      if (trIsMouseEnter > -1) {
        e = e || window.event
        e.stopPropagation()
        e.preventDefault()
        let _x = e.clientX || e.x
        let _y = e.clientY || e.y
        let contextMenuDom = document.querySelector('.contextMenu')
        contextMenuDom.style.left = 'auto'
        contextMenuDom.style.right = 'auto'
        contextMenuDom.style.top = 'auto'
        contextMenuDom.style.bottom = 'auto'

        let maxWidth = document.body.clientWidth
        if (maxWidth - _x <= 130) {
          contextMenuDom.style.right = '8px'
        } else {
          contextMenuDom.style.left = _x + 10 + 'px'
        }
        let maxHeight = document.body.clientHeight
        if (maxHeight - _y <= 260) {
          contextMenuDom.style.bottom = '8px'
        } else {
          contextMenuDom.style.top = _y + 10 + 'px'
        }

        // contextMenuDom.style.left = _x + 10 + 'px'
        // contextMenuDom.style.top = _y + 10 + 'px'
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        // GTJXT工程 右键菜单 全部置灰
        if (_self.isGTJXT(dataList[trIsMouseEnter])) {
          _self.contextMenuDisable = {
            viewModel: false,
            preview: true
          }
          // _self.judgeGTJXT()
          _self.judgePreview()
          _self.contextMenuShow = true
          return
        } else {
          if (_self.filePrivilege === 'delete' || _self.filePrivilege === 'grant') {
            _self.contextMenuDisable.delete = false
            _self.contextMenuDisable.download = false
            _self.contextMenuDisable.copyToCompanySpace = false
            _self.contextMenuDisable.move = false
          } else {
            _self.contextMenuDisable.delete = true
          }
        }
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        }
        _self.$nextTick(() => {
          _self.judgePreview()
          _self.contextMenuShow = true
        })
      }
    })

    let dragFilebox = document.querySelector('.dndCnt')
    on(document, 'dragleave', eventObj.dragleave = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (!_self.allFiles || _self.filePrivilege === 'view' || _self.isRecord) {
        return false
      }
      var handler

      handler = function () {
        _self.drawFileShow = false
      }
      clearTimeout(_self._leaveTimer)
      _self._leaveTimer = setTimeout(handler, 100)
      return false
    })
    on(document, 'dragenter', eventObj.dragenter = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (!_self.allFiles || _self.filePrivilege === 'view' || _self.isRecord) {
        return false
      }
      _self.drawFileShow = true
      return false
    })
    on(document, 'dragover', eventObj.dragover = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (!_self.allFiles || _self.filePrivilege === 'view' || _self.isRecord) {
        return false
      }
      clearTimeout(_self._leaveTimer)
      _self.drawFileShow = true
      return false
    })
    on(document, 'drop', eventObj.drop = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (!_self.allFiles || _self.filePrivilege === 'view' || _self.isRecord) {
        return false
      }
      _self.drawFileShow = false
      return false
    })
    on(dragFilebox, 'drop', function (e) {
      e.preventDefault() // 取消默认浏览器拖拽效果
      e.stopPropagation()
      if (!_self.allFiles || _self.filePrivilege === 'view' || _self.isRecord) {
        return false
      }
      let fileList = e.dataTransfer.files // 获取文件对象
      _self.drawFileShow = false
      if (fileList.length === 0) {
        return
      }
      let dataTransfer = e.dataTransfer
      let items = dataTransfer.items
      let files = dataTransfer.files
      let canAccessFolder = !!(items && items[0].webkitGetAsEntry)
      let results = []
      let len = files.length
      let promises = []

      for (let i = 0; i < len; i++) {
        let file = files[i]
        let item = items && items[i]
        if (canAccessFolder && item.webkitGetAsEntry().isDirectory) {
          promises.push(
            _traverseDirectoryTree(item.webkitGetAsEntry(), results)
          )
        } else {
          results.push(file)
        }
      }

      if (promises.length > 0) {
        Promise.all(promises).then(res => {
          let posilist = _handleDataFile(res)
          let files = [...results, ...posilist]
          if (files.length > 100) {
            _self.$message.info('文件过多，一次最多可以上传100个文件')
            return
          }
          Bus.$emit('addUploaderFiles', {
            files: files,
            parameter: {
              drag: true, // 拖拽上传
              workspaceId: getWorkspaceId(_self),
              filePath: _self.path
            }
          })
        })
      } else {
        if (results.length > 100) {
          _self.$message.warning('文件过多，一次最多可以上传100个文件')
          return
        }
        Bus.$emit('addUploaderFiles', {
          files: [...results],
          parameter: {
            drag: true, // 拖拽上传
            workspaceId: getWorkspaceId(_self),
            filePath: _self.path
          }
        })
        // this.$parent.prjStatus.prjStatus[this.activeTab] = 3;
      }
    })
  }, 200)
}

function _handleDataFile (res) {
  let main = [];
  (function _gData (data) {
    data.map(item => {
      if (Array.isArray(item)) {
        _gData(item)
      } else {
        main.push(item)
      }
    })
  })(res)
  return main
}

function _traverseDirectoryTree (entry, results, isDirectory) {
  return new Promise((resolve, reject) => {
    if (entry.isFile) {
      entry.file(function (file) {
        if (isDirectory) {
          file.fullPath = entry.fullPath
        }
        // results.push( file );
        resolve(file)
      })
    } else if (entry.isDirectory) {
      let promises = []
      let _dirReader = entry.createReader();
      (function _readEntries (_dirReader1) {
        _dirReader1.readEntries(function (entries) {
          var len = entries.length
          // var arr = []; // 为了保证顺序。
          var i
          //
          for (i = 0; i < len; i++) {
            promises.push(_traverseDirectoryTree(entries[i], [], true))
          }
          if (len === 100) {
            _readEntries(_dirReader1)
          } else {
            Promise.all(promises).then(res => {
              resolve(res)
            })
          }
        })
      })(_dirReader)
    }
  })
}

// 获取空间id
function getWorkspaceId (that, company) {
  if (that.tabletype === 'companyList' || company) {
    return getCookie('enterpriseWorkspaceIdValue')
  }
  if (that.tabletype === 'personalList') {
    return getCookie('personalWorkspaceIdValue')
  }
  if (that.tabletype === 'projectList') {
    return getCookie('projectWorkspaceIdValue')
  }
}

function getWorkspaceIdByType (type) {
  if (type === 'personal') {
    return getCookie('personalWorkspaceIdValue')
  }
  if (type === 'company') {
    return getCookie('enterpriseWorkspaceIdValue')
  }
  if (type === 'project') {
    return getCookie('projectWorkspaceIdValue')
  }
}

// 获取fileType
function getFileType (that) {
  // 个人空间
  // 文件类型需要存入localstorage中
  // let fileType
  // switch (that.tabletype) {
  //   case 'personalList':
  //     fileType = localStorage.getItem('personalFileType') || 0
  //     break
  //   case 'companyList':
  //     fileType = localStorage.getItem('companyFileType') || 0
  //     break
  //   case 'projectList':
  //     fileType = localStorage.getItem('projectFileType') || 0
  //     break
  //   default:
  //     fileType = 0
  //     break
  // }
  // fileType = fileType - 0
  // that.fileType = fileType
  // return fileType
  return 0
}

// 初始化数据
function initData (that, resetPager = false, search = false) {
  if (!resetPager) {
    that.pageNum = 1
    that.pageSize = 50
    that.total = 0
  }
  // 2021.3.19 ker 从工作台跳转，路由携带有分页或者目录路径时 -- start
  let query = that.$route.query
  const {pageNum, paths = ''} = query
  if (pageNum && /^[0-9]*$/.test(pageNum)) {
    // that.pageNum = Number(query.pageNum)
    that.pageSize = 50
  }
  if (paths) {
    let pathItems = [{name: '全部文件'}]
    that.path = '/' + paths
    const crumbs = paths.split('/')
    crumbs.slice(1).forEach((path, index) => {
      if (index === 0) {
        (path !== that.activeTab) && pathItems.push({name: path})
      } else {
        pathItems.push({name: path})
      }
    })
    that.pathItems = pathItems
  }
  // 2021.3.19 ker 从工作台跳转，路由携带有分页或者目录路径时 -- end
  /*
   if (resetPager || that.path === '/') {
    if (+that.prjType === 0) {
      that.path = (that.path === '/' ? '/' + that.prjName : that.path)
    } else {
      let tempPath = '/' + that.prjName + '/' + that.activeTab
      if (!that.path.includes(tempPath)) {
        that.path = '/' + that.prjName
        if (+that.prjType === 1 && that.activeTab && +that.tabType === 1){
          that.path = that.path + '/' + that.activeTab
        }

      }
    }
  } else if (that.path.indexOf('/' + that.prjName) !== 0) {
    if (+that.prjType === 1 && that.activeTab && +that.tabType === 1){
      that.path = '/' + that.prjName + '/' + that.activeTab + that.path
    } else {
      that.path = '/' + that.prjName + that.path
    }
  }
  * */
  /**
   tabType 1阶段搜索 0全局搜索
   prjType 1阶段存储项目 0自定义项目
   activeTab 阶段名称
  **/
  // 文件夹路径，面包屑
  const pathItems = that.pathItems.map((item, index) => {
    return ((index === 0 && item.name !== '全部文件') || index > 0 ? item.name : '')
  }).join('/')
  that.path = `/${that.prjName}/${that.prjType === 1 ? that.activeTab : ''}${pathItems}`
  let parameterPath
  if (that.prjType) {
    // 按阶段存储项目
    let path = search && that.tabType === 0 ? '' : `/${that.activeTab}${pathItems}` // 全局搜索时，activeTab pathItems为空
    parameterPath = `/${that.prjName}${path}`
  } else {
    // 自定义存储项目
    parameterPath = `/${that.prjName}${pathItems}`
  }
  if (that.path === '/') {
    return
  }
  let parameter = {
    path: parameterPath,
    workspaceId: getWorkspaceId(that),
    fileType: getFileType(that),
    sortFieldName: that.sortFieldName,
    sortType: that.sortType,
    pageNum: Number(query.pageNum) || that.pageNum,
    pageSize: that.pageSize,
    projectId: that.$route.params.id
  }
  let apiName = 'getFileList'
  if (that.searchVal) {
    apiName = 'getAllPrjSearch'
    parameter.id = that.$route.params.id
    parameter.key = that.searchVal
  }
  if (+that.tabType === 0 || !that.activeTab || +that.tabType === 0){
    apiName = 'getAllPrjList'
    parameter.id = that.$route.params.id
    if (that.searchVal) {
      apiName = 'getAllPrjSearch'
      parameter.key = that.searchVal
    }
  }
  that.loading = true
  SpaceService[apiName](parameter).then(res => {
    if (+that.tabType === 0) {
      that.isAllType = true
      that.$parent.searchAll = true
      if (search) {
        that.pathItems = [{name: `${that.getPathNameG()}`}]
      }
    } else {
      that.isAllType = false
      that.$parent.searchAll = false
    }
    that.renameData = {
      suffix: '',
      value: '',
      showIndex: -1
    }
    that.renameOk = false
    that.isRaname = false
    let data = res.data || {}
    let items = data.items || []
    let totalCount = data.totalCount || 0
    items.forEach(item => {
      // 带阶段文件列表
      if (item.stage) {
        for (let key in item.fileInfo){
          item[key] = item.fileInfo[key]
        }
      }
      item.size = sizeConver(item.length || 0)
      if (item.createTime) {
        item.createTime = formatDay(new Date(parseInt(item.createTime)))
      }
      if (item.modifyTime) {
        item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)))
      }
      // 我收到的分享工程文件夹 是虚拟文件夹 fileProperties 属性为 null 若不设置成对象 html 中会报错
      if (!item.fileProperties) {
        item.fileProperties = {}
      }
      if (+item.fileType === 1 && item.fileProperties.projectType) {
        item.extraInfo = that.getFileTypeHandle(item.fileProperties.projectType).extraInfo
      }
    })
    that.isCheckAll = false
    that.dataList = getFileTyeIconClass(items)
    that.total = totalCount
    that.pageNum = parameter.pageNum
    setTimeout(() => {
      handelTextBoxStyle(that)
    }, 300)
    // 2021.3.19 从工作台跳转
    that.$nextTick(() => {
      if (query.fileId) {
        let scrollElement = document.getElementById(query.fileId)
        scrollElement && scrollElement.scrollIntoView()
        that.$router.replace(that.$route.path)
      }
    })
    // 2021.3.19 从工作台跳转
  }).finally(() => {
    that.loading = false
  })
}

// 删除文件
function delFiles (that) {
  if (deleteFileList.length === 0) {
    return
  }
  SpaceService.deleteFile({
    pathList: deleteFileList.map(item => item.path),
    workspaceId: getWorkspaceId(that)
  }).then(result => {
    // that.delDialogShow = false
    if (+result.code === 200) {
      // that.recordsDataOpration(2, deleteFileList);
      that.addOperationRecords(2, deleteFileList)
      initData(that)
      // that.delDialogShow = false
      if (result.data && result.data.failure && result.data.failure.length > 0) {
        that.msg = {
          type: '删除',
          show: true,
          isShort: true,
          arr: result.data.failure.map(item => item.name)
        }
      } else {
        that.$message.success('删除成功')
      }
    } else if (+result.code === 403) {
      that.msg = {
        type: '删除',
        show: true,
        isShort: true,
        arr: deleteFileList.map(item => item.name)
      }
    } else if (+result.code === 270014) {
      if (result.data[0].filePath === result.data[0].lockUsers[0].filePath) {
        that.$confirm({
          message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
              (result.data[0].lockUsers[0].lockUserName
                ? result.data[0].lockUsers[0].lockUserName
                : '其他') +
              '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      } else if (result.data[0].filePath.indexOf(result.data[0].lockUsers[0].filePath) !== -1) {
        const projectname = result.data[0].lockUsers[0].filePath
          .split('/')
          .reverse()[0]
        that.$confirm({
          message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
              projectname +
              "）</em>正在被<em style='color: #1c6ccd;'>" +
              (result.data[0].lockUsers[0].lockUserName
                ? result.data[0].lockUsers[0].lockUserName
                : '其他') +
              '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      } else if (result.data[0].lockUsers[0].filePath.indexOf(result.data[0].filePath) !== -1) {
        const projectname = result.data[0].lockUsers[0].filePath
          .split('/')
          .reverse()[0]
        that.$confirm({
          message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
              projectname +
              "）</em>正在被<em style='color: #1c6ccd;'>" +
              (result.data[0].lockUsers[0].lockUserName
                ? result.data[0].lockUsers[0].lockUserName
                : '其他') +
              '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      }
    } else {
      that.$message.error(result.message ? result.message : '删除失败！')
    }
  }).catch((e) => {
  })
}

// 获取下载状态
function getDownloadFilesState (that, zipFileName, additional) {
  const { logData } = additional
  SpaceService.getDownloadFilesState().then(res => {
    clearTimeout(downLoadTimer)
    if (+res.code === 200) {
      if (res.data >= 100) {
        setTimeout(() => {
          that.$progress({closeAll: true})
        }, 100)
        logData.extJson.files.forEach(item => { item.status = 1 })
        that.sentLog(logData.fnCode, logData.extJson)
        // that.downloadProgressLaterShow = false;
        // that.downloadProgressValue = parseInt(res.data);
        that.showProgress('正在下载文件...', +res.data)
        let token = getCookie('ZJYTOKEN')
        zipFileName = encodeURIComponent(zipFileName)
        if (that.isRecord) {
          window.common.downloadFile(
            `${backendUrl}/projects/recorded/file/batch_download?zipFileName=${zipFileName}&token=${token}`
          )
        } else {
          window.common.downloadFile(
            `${backendUrl}/file/batch_download?zipFileName=${zipFileName}&token=${token}`
          )
        }
      } else if (+res.data === -1) {
        that.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
        // that.downloadProgressValue = 0;
        // that.downloadProgressLaterShow = false;
        // alert('下载失败')
        that.$progress({
          closeAll: true,
          close: () => {
            that.$message.error('下载失败')
          }
        })
      } else {
        // that.downloadProgressValue = parseInt(res.data);
        that.showProgress('正在下载文件...', +res.data)
        downLoadTimer = setTimeout(() => {
          getDownloadFilesState(that, zipFileName, additional)
        }, 1000)
      }
    }
  })
}

// 创建文件夹
function createdFolder (that) {
  let queryinput = document.querySelector('.renameInput')
  if (that.isRaname && queryinput) {
    setTimeout(() => {
      queryinput.setSelectionRange(0, 5)
      queryinput.focus()
    }, 100)
    return
  }
  that.renameData = {
    suffix: '',
    value: '',
    showIndex: 0
  }
  that.renameOk = false
  const newFolderItem = {
    isCreateFolder: 1,
    value: '',
    folder: true,
    fileProperties: {},
    icons: 'iconfolders'
  }
  let datalist = JSON.parse(JSON.stringify(that.dataList))
  datalist.unshift(newFolderItem)
  that.renameData.value = '新建文件夹'
  that.isRaname = true
  that.dataList = datalist
  setTimeout(() => {
    let queryinput = document.querySelector('.renameInput')
    queryinput.setSelectionRange(0, 5)
    queryinput.focus()
  }, 100)
}
//
function handelTextBoxStyle (that) {
  let personTextboxAll
  if (that.typeFilterData === 'list') {
    personTextboxAll = document.querySelectorAll('.trItem')
  } else {
    personTextboxAll = document.querySelectorAll('.imgItem')
  }
  let w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
  let h =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight

  let tableBodyWrapper = that.typeFilterData === 'list' ? document.querySelector('.table-body-wrapper') : document.querySelector('.listcnt')
  let tablieBodyScrollTop = tableBodyWrapper ? tableBodyWrapper.scrollTop : 0
  for (let i = 0; i < personTextboxAll.length; i++) {
    if (personTextboxAll[i].querySelector('.person-textbox')) {
      if (that.typeFilterData === 'list') {
        if (personTextboxAll[i].offsetTop + 560 - tablieBodyScrollTop > h) {
          personTextboxAll[i].querySelector('.person-textbox').style.top = 'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.bottom = '0'
        }
      } else {
        if (personTextboxAll[i].offsetLeft + 600 > w) {
          personTextboxAll[i].querySelector('.person-textbox').style.left =
              'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.right =
              '90%'
        } else {
          personTextboxAll[i].querySelector('.person-textbox').style.left = '120px'
          personTextboxAll[i].querySelector('.person-textbox').style.right = 'auto'
        }
      }
    }
  }
}
</script>
<style lang="less" type="text/less">
body{
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
    font-weight: 600;
    color: rgba(33,37,48,1);
  }
  .file_search{
    margin-left: 115px;
    /*.w__input__inner {*/
      /*&:focus {*/
        /*outline: none;*/
        /*box-shadow: none;*/
        /*border-color: #DCDFE6;*/
      /*}*/
    /*}*/
    .w__input [class^=r2-icon-] {
      font-size: 20px !important;
    }
    .r2-icon-action_search{
      font-size: 20px !important;
    }
  }
  .file_search_all{
    margin-left: -2px;
    .w__input__inner{
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .file_select{
    .w__input__inner{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .w__input.is-focus .w__input__inner{
      border-color: #C0C4CC;
    }
    .w__input__inner:focus{
      box-shadow: unset;
    }
  }
  .w-rename {
    background: transparent;
  }
  .pri_content{
    height: 365px;
    .pri_header{
      height: 40px;
      line-height: 40px;
      background:rgba(243,244,247,1);
      box-shadow:0px 1px 0px 0px rgba(33,37,48,0.15);
      margin: 0;
    }
    .pri_body{
      height: 230px;
      overflow: auto;
      .pri_tr{
        height: 56px;
        line-height: 56px;
        box-shadow:0px 1px 0px 0px rgba(33,37,48,0.1);
        margin: 0;
      }
      .pri_item_4{
        width: 330px;
      }
    }
    .pri_foot{
      text-align: right;
      margin-right: 24px;
      margin-top: 23px;
    }
    .pri_item{
      float: left;
      box-sizing: border-box;
      padding: 0 24px;
      padding-right: 0;
    }
    .pri_item_1{
      width: 160px;
    }
    .pri_item_2{
      width: 240px;
    }
    .pri_item_3{
      width: 120px;
    }
    .pri_item_4{
      width: 300px;
    }
  }
  .pri-title {
    width: 450px;
    padding: 0 10px;
    line-height: 44px;
    span {
      display: inline-block;
      &:nth-child(1) {
        text-align: left;
        font-size: 12px;
        width: 120px;
      }
      &:nth-child(2) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(3) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(4) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(5) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
    }
  }
  .pri-cnt {
    padding: 0 10px;
    width: 460px;
    box-sizing: border-box;
    span {
      display: inline-block;
      line-height: 32px;
      &:nth-child(1) {
        text-align: left;
        font-size: 12px;
        width: 120px;
      }
      &:nth-child(2) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(3) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(4) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(5) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
    }
  }
  .del-doalog {
    width: 320px;
  }
  .icon-name_cont {
    position: relative;

    .invalid_flag {
      display: block;
      position: absolute;
      left: 10px;
      top: -3px;
      background-color: #7b7b7b;
      color: #fff;
      padding: 2px 5px;
      border-radius: 4px;
      z-index: 10;
    }
  }
  .privilege-dialog{
    width: 880px;
    .w__dialog--header{
      padding: 0;
      height: 56px;
      padding-left: 24px;
      line-height: 56px;
      border-bottom: none;
    }
    .w__dialog--body{
      padding: 0;
    }
  }
}
</style>
<style lang="less" scoped>
  @import "~@/components/common/ProjectTable/Index.less";
  .project-files{
    margin-left: 24px;
    margin-right: 24px;
  }
  tbody tr{
    height: 56px;
  }
  .page-box{
    text-align: right;
  }
</style>

